var KLAVIYO_LIST_ID = 'RZEGU2';

/* ── OFFRE ROUTINE COMPLETE ──
   ROUTINE_AUTO = true  : reduction AUTOMATIQUE Shopify (aucun code a passer).
                          Elle s'applique des que le panier atteint la condition,
                          y compris via les boutons "+" un par un.
   ROUTINE_AUTO = false : reduction par code, ROUTINE_CODE est alors applique. */
var ROUTINE_AUTO = true;
var ROUTINE_CODE = 'ROUTINE15';
var ROUTINE_PCT  = 15;
var ROUTINE_MIN  = 2;              // nb d'articles a partir duquel la remise tombe
/* Produits presentes dans les resultats mais exclus du lot "routine complete" :
   ils restent visibles et achetables a l'unite, en option. */
var BUNDLE_EXCLUDE = ['/products/serum-cils-sourcils-growth'];
var OPTION_LABEL   = 'En option, pour un regard sublim\u00e9';
var SHOP_ORIGIN  = 'https://nocee.fr';

var NQ = [
  {id:'type',cat:'Type de peau',multi:false,
   q:'Comment se comporte votre peau en milieu de journ\u00e9e, sans aucun soin ?',
   hint:'Observez 4 \u00e0 5h apr\u00e8s le nettoyage du matin, sans cr\u00e8me ni s\u00e9rum.',choices:[
    {l:'Elle tire et est inconfortable, sensation de peau qui colle',v:'seche'},
    {l:'Elle brille sur le front, nez et menton, joues normales ou s\u00e8ches',v:'mixte'},
    {l:'Elle brille sur toutes les zones, pores visibles partout',v:'grasse'},
    {l:'Elle semble \u00e9quilibr\u00e9e, ni s\u00e8che ni grasse',v:'normale'},
    {l:'Elle tire ET brille selon les zones, mixte d\u00e9s\u00e9quilibr\u00e9e',v:'mixte_deshydratee'},
  ]},
  {id:'sensibilite',cat:'R\u00e9activit\u00e9 cutan\u00e9e',multi:false,
   q:'Votre peau r\u00e9agit-elle facilement \u00e0 un nouveau produit ?',
   hint:'Rougeurs, picotements, boutons ou bouff\u00e9es de chaleur dans les 24 \u00e0 48h.',choices:[
    {l:'Oui, presque toujours, rougeurs ou picotements imm\u00e9diats',v:'tres_sensible'},
    {l:'Parfois, selon les formules, surtout alcool et parfums',v:'sensible'},
    {l:'Rarement, uniquement avec certains ingr\u00e9dients sp\u00e9cifiques',v:'peu_sensible'},
    {l:'Jamais, ma peau tol\u00e8re tout sans r\u00e9action',v:'non_sensible'},
  ]},
  {id:'hydratation',cat:'Hydratation & barri\u00e8re',multi:false,
   q:'Comment r\u00e9agit votre peau apr\u00e8s le nettoyage, avant d\'appliquer un soin ?',
   hint:'Ce ressenti r\u00e9v\u00e8le l\'\u00e9tat de votre barri\u00e8re cutan\u00e9e hydrolipidique.',choices:[
    {l:'Tiraillements imm\u00e9diats, peau inconfortable d\u00e8s le rin\u00e7age',v:'barriere_alteree'},
    {l:'L\u00e9g\u00e8re g\u00eane qui dispara\u00eet dans les 5 minutes',v:'barriere_fragilisee'},
    {l:'Aucun inconfort, peau \u00e0 l\'aise apr\u00e8s nettoyage',v:'barriere_integre'},
    {l:'Peau grasse imm\u00e9diatement apr\u00e8s nettoyage',v:'sebum_reactif'},
  ]},
  {id:'imperfections',cat:'Imperfections',multi:true,
   q:'Quelles imperfections observez-vous sur votre peau ?',
   hint:'S\u00e9lectionnez tout ce qui s\'applique \u00e0 votre situation actuelle.',choices:[
    {l:'Boutons inflammatoires rouges r\u00e9currents',v:'inflammatoire'},
    {l:'Points noirs et com\u00e9dons ouverts',v:'comedons'},
    {l:'Kystes profonds sous la peau',v:'kystique'},
    {l:'Imperfections qui apparaissent avant les r\u00e8gles',v:'hormonal'},
    {l:'Boutons uniquement en p\u00e9riode de stress',v:'stress_acne'},
    {l:'Ma peau est globalement nette sans imperfections',v:'nette'},
  ]},
  {id:'taches',cat:'Teint & pigmentation',multi:true,
   q:'Quelles irr\u00e9gularit\u00e9s de teint observez-vous ?',
   hint:'Soyez pr\u00e9cise, le type de tache d\u00e9termine l\'actif adapt\u00e9.',choices:[
    {l:'Taches brunes li\u00e9es au soleil, zones expos\u00e9es',v:'taches_solaires'},
    {l:'Masque de grossesse ou taches hormonales, joues et front',v:'melasma'},
    {l:'Traces sombres laiss\u00e9es par d\'anciens boutons',v:'post_acne'},
    {l:'Teint terne et gris\u00e2tre, sans taches d\u00e9finies',v:'terne'},
    {l:'Rougeurs diffuses ou couperose visible',v:'rougeurs'},
    {l:'Mon teint est homog\u00e8ne et lumineux',v:'teint_uniforme'},
  ]},
  {id:'age',cat:'Profil & physiologie',multi:false,
   q:'Dans quelle tranche d\'\u00e2ge vous situez-vous ?',
   hint:'La physiologie cutan\u00e9e change significativement \u00e0 chaque d\u00e9cennie.',choices:[
    {l:'Moins de 25 ans, production de s\u00e9bum souvent \u00e9lev\u00e9e',v:'moins25'},
    {l:'25 \u00e0 35 ans, premi\u00e8re apparition de fines lignes',v:'25_35'},
    {l:'35 \u00e0 45 ans, d\u00e9but du ralentissement du renouvellement cellulaire',v:'35_45'},
    {l:'Plus de 45 ans, chute hormonale et perte de densit\u00e9',v:'plus45'},
  ]},
  {id:'mode_de_vie',cat:'Facteurs environnementaux',multi:true,
   q:'Quels facteurs d\u00e9crivent votre quotidien ?',
   hint:'Ces \u00e9l\u00e9ments sont des d\u00e9clencheurs cutan\u00e9s document\u00e9s, cochez tout ce qui s\'applique.',choices:[
    {l:'Stress chronique ou manque de sommeil r\u00e9gulier (< 6h)',v:'stress'},
    {l:'Ville, exposition quotidienne \u00e0 la pollution et aux particules fines',v:'pollution'},
    {l:'Sport intensif avec transpiration abondante',v:'sport'},
    {l:'Travail devant \u00e9cran plus de 8h/jour',v:'ecran'},
    {l:'Tabagisme actif ou passif fr\u00e9quent',v:'tabac'},
    {l:'Aucun de ces facteurs, environnement \u00e9quilibr\u00e9',v:'equilibre'},
  ]},
  {id:'alimentation',cat:'Alimentation & inflammation',multi:false,
   q:'Votre alimentation est globalement...',
   hint:'Le microbiome intestinal et la peau communiquent directement via l\'axe intestin-peau.',choices:[
    {l:'Riche en sucre raffin\u00e9, produits ultra-transform\u00e9s, fast-food',v:'pro_inflammatoire'},
    {l:'\u00c9quilibr\u00e9e avec des \u00e9carts r\u00e9guliers',v:'moyenne'},
    {l:'Riche en l\u00e9gumes, om\u00e9ga-3, peu de sucre ajout\u00e9',v:'anti_inflammatoire'},
    {l:'Alimentation irr\u00e9guli\u00e8re, je ne fais pas attention',v:'non_suivi'},
  ]},
  {id:'nettoyage',cat:'Protocole de nettoyage',multi:false,
   q:'Quel nettoyant utilisez-vous actuellement ?',
   hint:'Le type de nettoyant impacte directement le pH cutan\u00e9 (5,5) et la barri\u00e8re hydrolipidique.',choices:[
    {l:'Savon solide ou nettoyant moussant puissant, sensation de peau qui "tire"',v:'agressif'},
    {l:'Gel nettoyant grande surface avec SLS ou SLES',v:'sls'},
    {l:'Nettoyant doux sans sulfates agressifs',v:'doux'},
    {l:'Eau micellaire seule, sans rin\u00e7age',v:'micellaire'},
    {l:'Je ne nettoie pas ou tr\u00e8s rarement',v:'sans_nettoyage'},
  ]},
  {id:'routine_actuelle',cat:'Routine actuelle',multi:false,
   q:'Combien de produits composent votre routine visage actuelle ?',
   hint:'Nettoyant, tonique, essence, s\u00e9rum, contour yeux, cr\u00e8me, huile, masques, correcteurs...',choices:[
    {l:'Aucun produit, je pars de z\u00e9ro',v:'zero'},
    {l:'1 \u00e0 2 produits, routine minimaliste',v:'minimal'},
    {l:'3 \u00e0 5 produits, routine mod\u00e9r\u00e9e',v:'moyen'},
    {l:'6 produits ou plus, routine complexe',v:'complexe'},
  ]},
  {id:'objectif',cat:'Objectif prioritaire',multi:true,
   q:'Qu\'attendez-vous principalement de votre routine ?',
   hint:'Choisissez vos objectifs r\u00e9els, pas ce que vous pensez devoir r\u00e9pondre.',choices:[
    {l:'Retrouver de l\'\u00e9clat et une peau lumineuse',v:'eclat'},
    {l:'R\u00e9duire les imperfections et r\u00e9guler le s\u00e9bum',v:'imperfections'},
    {l:'Hydrater durablement et calmer les r\u00e9actions',v:'hydratation'},
    {l:'Att\u00e9nuer les taches et unifier le teint',v:'taches'},
    {l:'Ralentir les signes du temps, fermet\u00e9 et densit\u00e9',v:'antiage'},
  ]},
  {id:'spf',cat:'Protection solaire',multi:false,
   q:'Utilisez-vous une protection solaire sur le visage tous les matins ?',
   hint:'Les UVA (vieillissement) traversent nuages, vitres et tissus 365 jours/an. Indice r\u00e9el minimum : SPF 50.',choices:[
    {l:'Oui, SPF 50 ou SPF 50+ chaque matin sans exception',v:'spf_50'},
    {l:'Oui, mais SPF inf\u00e9rieur \u00e0 50 ou pas tous les jours',v:'spf_insuffisant'},
    {l:'Seulement en \u00e9t\u00e9 ou lors d\'expositions prolong\u00e9es',v:'spf_ete'},
    {l:'Rarement ou jamais',v:'spf_non'},
  ]},
];

var POUDRE_SOIR = 'Poudre Nettoyante Exfoliante 2-en-1 (1 \u00e0 2 fois/semaine le soir) : verser quelques gouttes d\'eau ti\u00e8de ou fra\u00eeche dans la paume, jamais chaude. M\u00e9langer avec la poudre sur peau humide. Rincer soigneusement. Les autres soirs : nettoyage avec un nettoyant lavant doux ou une huile lavante.';
var POUDRE_ORDRE = 'Soir : 1 \u00e0 2 fois par semaine sur peau humide';
var FONT_MONO = "'TT Interphase Mono','SF Mono',monospace";
var FONT_SERIF = "'Kaisei Tokumin',Georgia,serif";
var C_TEXT = '#1C1C1C';
var C_MUTED = '#6E685F';
var C_ACCENT = '#bc5703';
var C_BG = '#F5F2EA';
var C_BORDER = '#E0D9CA';

var PRODUCT_IMAGES = {
  '/products/serum-hydratant': 'https://nocee.fr/cdn/shop/files/Nocee_serum_hydratant_booster.jpg?v=1781685537&width=1646',
  '/products/serum-regulateur-sebum-zinc-pca': 'https://nocee.fr/cdn/shop/files/Nocee_serum_regulateur_sebum_Zinc_PCA.jpg?v=1781685490&width=1646',
  '/products/serum-anti-taches': 'https://nocee.fr/cdn/shop/files/Nocee_serum_unifiant_anti_imperfections.jpg?v=1781685430&width=1646',
  '/products/poudre-nettoyante-et-exfoliante': 'https://nocee.fr/cdn/shop/files/Poudre_exfoliante_nocee.webp?v=1786374896&width=1646',
  '/products/serum-cils-sourcils-growth': 'https://nocee.fr/cdn/shop/files/Serum_growth_cils_sourcils_nocee.webp?v=1786365933&width=1051'
};

var NA={},NHIST=[],NCUR=0,NPRENOM='',NEMAIL='',NPRODUITS=[];

function ndStart(){
  document.getElementById('nd-intro').style.display='none';
  document.getElementById('nd-question').style.display='block';
  ndShowQ(0);
}

function ndShowQ(i){
  NCUR=i;
  var q=NQ[i];
  document.getElementById('ndq-num').textContent='Question '+(i+1)+' / '+NQ.length;
  document.getElementById('ndq-cat').textContent=q.cat;
  document.getElementById('ndq-text').textContent=q.q;
  document.getElementById('ndq-hint').textContent=q.hint;
  document.getElementById('nd-prog').style.width=Math.round(((i+1)/NQ.length)*100)+'%';
  document.getElementById('nd-back').style.visibility=i===0?'hidden':'visible';
  document.getElementById('ndq-multi-hint').style.display=q.multi?'flex':'none';

  var current=NA[q.id]||[];
  if(!Array.isArray(current)) current=[current];

  document.getElementById('ndq-choices').innerHTML=q.choices.map(function(c){
    var isSel=current.indexOf(c.v)>-1;
    var cls='nq-btn'+(q.multi?'':' single')+(isSel?' sel':'');
    return '<button class="'+cls+'" data-id="'+q.id+'" data-val="'+c.v+'" data-multi="'+q.multi+'">'+c.l+'</button>';
  }).join('');

  var btns=document.querySelectorAll('#ndq-choices .nq-btn');
  btns.forEach(function(btn){
    btn.addEventListener('click',function(){
      ndToggle(btn.getAttribute('data-id'),btn.getAttribute('data-val'),btn.getAttribute('data-multi')==='true');
    });
  });

  var btn=document.getElementById('nd-continue');
  btn.className='nq-continue'+(q.multi&&current.length>0?' visible':'');
}

function ndToggle(id,val,isMulti){
  if(isMulti){
    var arr=Array.isArray(NA[id])?NA[id].slice():[];
    var exclusifs=['nette','teint_uniforme','equilibre'];
    if(exclusifs.indexOf(val)>-1){
      arr=[val];
    } else {
      arr=arr.filter(function(v){return exclusifs.indexOf(v)===-1;});
      var idx=arr.indexOf(val);
      if(idx>-1) arr.splice(idx,1);
      else arr.push(val);
    }
    NA[id]=arr;
    var btns=document.querySelectorAll('#ndq-choices .nq-btn');
    NQ[NCUR].choices.forEach(function(c,i){
      if(arr.indexOf(c.v)>-1) btns[i].classList.add('sel');
      else btns[i].classList.remove('sel');
    });
    var btn=document.getElementById('nd-continue');
    btn.className='nq-continue'+(arr.length>0?' visible':'');
  } else {
    NA[id]=[val];
    NHIST.push(NCUR);
    if(NCUR<NQ.length-1) ndShowQ(NCUR+1);
    else ndGoEmail();
  }
}

function ndContinue(){
  var arr=NA[NQ[NCUR].id]||[];
  if(!Array.isArray(arr)||arr.length===0) return;
  NHIST.push(NCUR);
  if(NCUR<NQ.length-1) ndShowQ(NCUR+1);
  else ndGoEmail();
}

function ndBack(){
  if(NHIST.length>0){var p=NHIST.pop();ndShowQ(p);}
}

function ndGoEmail(){
  document.getElementById('nd-question').style.display='none';
  document.getElementById('nd-email').style.display='block';
}

function ndSubmitEmail(){
  var prenom=document.getElementById('nd-prenom').value.trim();
  var email=document.getElementById('nd-email-val').value.trim();
  var errEl=document.getElementById('nd-email-error');
  if(!prenom||!email||email.indexOf('@')===-1||email.indexOf('.')===-1){
    errEl.style.display='block';return;
  }
  errEl.style.display='none';
  NPRENOM=prenom;NEMAIL=email;
  var diagUrl = ndBuildUrl(NA, prenom);

  // Calculer les résultats AVANT l'envoi Klaviyo
  var resultData = ndComputeResults();

  // Affichage immediat des resultats, l'envoi Klaviyo suit
  document.getElementById('nd-email').style.display='none';
  ndRenderResults(resultData);

  // L'envoi Klaviyo ne doit JAMAIS dependre du reseau Shopify.
  // On tente d'obtenir un lien panier pre-rempli, mais un filet de securite
  // declenche l'envoi de toute facon au bout de 2,6 s.
  var envoiFait=false;
  function ndEnvoyer(bundleUrl,origine){
    if(envoiFait) return;
    envoiFait=true;
    console.log('[Diagnostic] envoi Klaviyo ('+origine+')');
    try{
      ndKlaviyoSubscribe(prenom,email,NA,diagUrl,resultData,bundleUrl);
    }catch(err){
      console.log('[Diagnostic] ERREUR pendant l\'envoi :',err);
    }
  }

  setTimeout(function(){ ndEnvoyer(diagUrl,'filet de securite'); },2600);

  try{
    ndBuildCartPermalink(resultData.produits,diagUrl)
      .then(function(bundleUrl){ ndEnvoyer(bundleUrl,'lien panier'); })
      .catch(function(e){
        console.log('[Diagnostic] lien panier impossible :',e);
        ndEnvoyer(diagUrl,'repli');
      });
  }catch(e){
    console.log('[Diagnostic] lien panier impossible :',e);
    ndEnvoyer(diagUrl,'repli immediat');
  }
}

function ndKlaviyoSubscribe(prenom,email,answers,diagUrl,resultData,bundleUrl){
  function flat(val){
    if(!val) return '';
    return Array.isArray(val)?val.join(', '):val;
  }

  var F="'TT Interphases Mono','Courier New',Courier,monospace";
  var FS="'Kaisei Tokumin',Georgia,serif";

  // ── HTML SCORES ──
  var sk=Object.keys(resultData.scores);
  var scoresHtml='<table width="100%" cellpadding="0" cellspacing="0" border="0"><tr>';
  sk.forEach(function(k,i){
    scoresHtml+='<td style="text-align:center;width:33%;padding:24px 8px;'+(i<sk.length-1?'border-right:1px solid #E0D9CA;':'')+'"><p style="font-family:'+FS+';font-size:28px;font-weight:400;color:#B05C1E;margin:0 0 6px;">'+resultData.scores[k]+'%</p><p style="font-family:'+F+';font-size:9px;letter-spacing:2px;color:#6E685F;text-transform:uppercase;margin:0;">'+k+'</p></td>';
  });
  scoresHtml+='</tr></table>';

  // ── HTML PRODUITS ──
  // Mise en page empilée (image au-dessus, texte en dessous) : lisible sur mobile
  // sans media query, donc compatible avec tous les clients mail.
  var produitsHtml='';
  resultData.produits.forEach(function(p,pi){
    var img=PRODUCT_IMAGES[p.u]||'';
    var url='https://nocee.fr'+p.u;
    var isLast=(pi===resultData.produits.length-1);
    produitsHtml+='<table width="100%" cellpadding="0" cellspacing="0" border="0" style="margin:0 0 32px;"><tr><td style="padding:0 0 32px;'+(isLast?'':'border-bottom:1px solid #E0D9CA;')+'">';
    produitsHtml+='<table width="100%" cellpadding="0" cellspacing="0" border="0">';
    if(img) produitsHtml+='<tr><td style="padding:0 0 22px;"><a href="'+url+'" target="_blank"><img src="'+img+'" alt="'+p.n+'" width="520" style="width:100%;max-width:520px;height:auto;display:block;border:0;outline:none;text-decoration:none;" /></a></td></tr>';
    produitsHtml+='<tr><td style="padding:0;">';
    if(p.star) produitsHtml+='<p style="font-family:'+F+';font-size:9px;letter-spacing:3px;color:#B05C1E;text-transform:uppercase;margin:0 0 12px;">Priorit\u00e9 1</p>';
    if(ndEstOption(p)) produitsHtml+='<p style="font-family:'+F+';font-size:9px;letter-spacing:2px;color:#6E685F;text-transform:uppercase;margin:0 0 12px;border:1px solid #E0D9CA;border-radius:40px;padding:5px 13px;display:inline-block;">'+OPTION_LABEL+'</p>';
    produitsHtml+='<p style="font-family:'+F+';font-size:9px;letter-spacing:3px;color:#B05C1E;text-transform:uppercase;margin:0 0 8px;line-height:1.6;">'+p.a+'</p>';
    produitsHtml+='<p style="font-family:'+FS+';font-size:21px;font-weight:400;color:#1C1C1C;margin:0 0 12px;line-height:1.35;">'+p.n+'</p>';
    produitsHtml+='<p style="font-family:'+F+';font-size:13px;color:#6E685F;line-height:2;margin:0 0 12px;">'+p.d+'</p>';
    produitsHtml+='<p style="font-family:'+F+';font-size:11px;color:#B05C1E;line-height:1.8;margin:0 0 18px;">'+p.ordre+'</p>';
    produitsHtml+='<p style="font-family:'+FS+';font-size:22px;font-weight:400;color:#1C1C1C;margin:0 0 18px;">'+p.p+'</p>';
    produitsHtml+='<a href="'+url+'" target="_blank" style="display:block;background-color:#B05C1E;color:#ffffff;text-decoration:none;padding:15px 24px;font-family:'+F+';font-size:12px;border-radius:50px;letter-spacing:1px;text-align:center;">Voir le produit \u2192</a>';
    produitsHtml+='</td></tr></table>';
    produitsHtml+='</td></tr></table>';
  });

  // ── Bloc "routine complete" en fin de liste produits ──
  try{
  var lotEmail=ndProduitsDuLot(resultData.produits);
  if(lotEmail.length>=ROUTINE_MIN){
    var t=ndRoutineTotaux(lotEmail);
    var lien=bundleUrl||(SHOP_ORIGIN+'/collections/les-essentiels');
    produitsHtml+='<table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:#B05C1E;border-radius:16px;margin:8px 0 0;"><tr><td style="padding:30px 26px;">';
    produitsHtml+='<p style="font-family:'+F+';font-size:9px;letter-spacing:3px;color:rgba(245,242,234,.7);text-transform:uppercase;margin:0 0 10px;">Votre routine compl\u00e8te</p>';
    produitsHtml+='<p style="font-family:'+FS+';font-size:22px;font-weight:400;color:#F5F2EA;margin:0 0 12px;line-height:1.3;">Les '+t.n+' produits de votre protocole, '+ROUTINE_PCT+'\u00a0% de remise.</p>';
    produitsHtml+='<p style="font-family:'+F+';font-size:12px;color:rgba(245,242,234,.85);line-height:1.9;margin:0 0 18px;">Ils ont \u00e9t\u00e9 s\u00e9lectionn\u00e9s pour agir ensemble, dans cet ordre pr\u00e9cis. Le panier est d\u00e9j\u00e0 pr\u00e9par\u00e9, la remise s\u2019applique automatiquement.</p>';
    produitsHtml+='<p style="font-family:'+FS+';font-size:15px;color:rgba(245,242,234,.6);margin:0 0 4px;"><span style="text-decoration:line-through;">'+ndEuros(t.total)+'</span></p>';
    produitsHtml+='<p style="font-family:'+FS+';font-size:28px;color:#F5F2EA;margin:0 0 20px;line-height:1;">'+ndEuros(t.final)+'</p>';
    produitsHtml+='<a href="'+lien+'" target="_blank" style="display:block;background-color:#F5F2EA;color:#B05C1E;text-decoration:none;padding:16px 24px;font-family:'+F+';font-size:12px;border-radius:50px;letter-spacing:1px;text-align:center;font-weight:500;">Ajouter ma routine compl\u00e8te \u2192</a>';
    produitsHtml+='</td></tr></table>';
  }
  }catch(e){ console.log('[Diagnostic] bloc offre ignore :',e); }

  // ── HTML ROUTINE ──
  // Sans bandeau noir ni encadrement : simple titre accent + filet, comme le reste du mail.
  var routineHtml='';
  resultData.routine.forEach(function(r){
    routineHtml+='<table width="100%" cellpadding="0" cellspacing="0" border="0" style="margin:0 0 36px;">';
    routineHtml+='<tr><td style="padding:0 0 12px;"><p style="font-family:'+F+';font-size:10px;letter-spacing:4px;color:#B05C1E;text-transform:uppercase;margin:0;line-height:1.6;">'+r.m+'</p></td></tr>';
    routineHtml+='<tr><td style="padding:0 0 20px;"><table cellpadding="0" cellspacing="0" border="0"><tr><td width="32" height="1" style="background-color:#B05C1E;font-size:0;line-height:0;">&nbsp;</td></tr></table></td></tr>';
    routineHtml+='<tr><td style="padding:0;">';
    r.s.forEach(function(s,i){
      routineHtml+='<table width="100%" cellpadding="0" cellspacing="0" border="0" style="'+(i>0?'margin-top:18px;':'')+'"><tr><td width="34" style="vertical-align:top;"><div style="background-color:#B05C1E;color:#ffffff;border-radius:50%;width:24px;height:24px;text-align:center;line-height:24px;font-family:'+F+';font-size:11px;">'+(i+1)+'</div></td><td style="padding-left:12px;vertical-align:top;"><p style="font-family:'+F+';font-size:13px;color:#1C1C1C;line-height:1.9;margin:0;">'+s+'</p></td></tr></table>';
    });
    routineHtml+='</td></tr></table>';
  });

  // ── HTML FACTEURS ──
  var facteursHtml='';
  resultData.facteurs.forEach(function(f){
    facteursHtml+='<table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-bottom:1px solid #E0D9CA;"><tr><td width="24" style="vertical-align:top;padding:14px 0;font-family:'+F+';font-size:13px;color:#B05C1E;">\u2192</td><td style="vertical-align:top;padding:14px 0;"><p style="font-family:'+F+';font-size:13px;font-weight:bold;color:#1C1C1C;margin:0 0 4px;">'+f.t+'</p><p style="font-family:'+F+';font-size:12px;color:#6E685F;line-height:1.8;margin:0;">'+f.d+'</p></td></tr></table>';
  });

  // ── HTML CONSEILS ──
  var conseilsHtml='';
  resultData.tousConseils.forEach(function(c){
    conseilsHtml+='<table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-bottom:1px solid #E0D9CA;"><tr><td width="24" style="vertical-align:top;padding:14px 0;font-family:'+F+';font-size:13px;color:#B05C1E;">\u2192</td><td style="vertical-align:top;padding:14px 0;"><p style="font-family:'+F+';font-size:13px;font-weight:bold;color:#1C1C1C;margin:0 0 4px;">'+c.t+'</p><p style="font-family:'+F+';font-size:12px;color:#6E685F;line-height:1.8;margin:0;">'+c.d+'</p></td></tr></table>';
  });

  var payload={data:{type:'subscription',attributes:{
    list_id:KLAVIYO_LIST_ID,email:email,
    custom_source:'Diagnostic Peau Noc\u00e9e V3',
    properties:{
      first_name:prenom,
      diag_type_peau:flat(answers.type),
      diag_sensibilite:flat(answers.sensibilite),
      diag_hydratation:flat(answers.hydratation),
      diag_imperfections:flat(answers.imperfections),
      diag_taches:flat(answers.taches),
      diag_age:flat(answers.age),
      diag_mode_de_vie:flat(answers.mode_de_vie),
      diag_alimentation:flat(answers.alimentation),
      diag_nettoyage:flat(answers.nettoyage),
      diag_routine:flat(answers.routine_actuelle),
      diag_objectif:flat(answers.objectif),
      diag_spf:flat(answers.spf),
      diag_url:diagUrl||'',
      diag_profil: resultData.profil,
      diag_profil_desc: resultData.desc,
      diag_mecanisme: resultData.mecanisme||'',
      diag_spf_titre: resultData.spfMsg.t,
      diag_spf_desc: resultData.spfMsg.d,
      diag_html_scores: scoresHtml,
      diag_html_produits: produitsHtml,
      diag_html_routine: routineHtml,
      diag_html_facteurs: facteursHtml,
      diag_html_conseils: conseilsHtml,
    }
  } } };
  fetch('https://a.klaviyo.com/client/subscriptions/?company_id=V7ixtx',{
    method:'POST',
    headers:{'Content-Type':'application/json','revision':'2023-02-22'},
    body:JSON.stringify(payload)
  }).catch(function(e){console.log('Klaviyo diag list:',e);});

  var payloadMain={data:{type:'subscription',attributes:{
    list_id:'S3qNBD',email:email,
    custom_source:'Diagnostic Peau Noc\u00e9e V3',
    properties:{first_name:prenom}
  }}};
  fetch('https://a.klaviyo.com/client/subscriptions/?company_id=V7ixtx',{
    method:'POST',
    headers:{'Content-Type':'application/json','revision':'2023-02-22'},
    body:JSON.stringify(payloadMain)
  }).catch(function(e){console.log('Klaviyo main list:',e);});

  // ── IDENTIFY : force la mise à jour des propriétés même si déjà abonné ──
  var allProps = {
    first_name:prenom,
    diag_type_peau:flat(answers.type),
    diag_sensibilite:flat(answers.sensibilite),
    diag_hydratation:flat(answers.hydratation),
    diag_imperfections:flat(answers.imperfections),
    diag_taches:flat(answers.taches),
    diag_age:flat(answers.age),
    diag_mode_de_vie:flat(answers.mode_de_vie),
    diag_alimentation:flat(answers.alimentation),
    diag_nettoyage:flat(answers.nettoyage),
    diag_routine:flat(answers.routine_actuelle),
    diag_objectif:flat(answers.objectif),
    diag_spf:flat(answers.spf),
    diag_url:diagUrl||'',
    diag_profil: resultData.profil,
    diag_profil_desc: resultData.desc,
    diag_mecanisme: resultData.mecanisme||'',
    diag_spf_titre: resultData.spfMsg.t,
    diag_spf_desc: resultData.spfMsg.d,
    diag_html_scores: scoresHtml,
    diag_html_produits: produitsHtml,
    diag_html_routine: routineHtml,
    diag_html_facteurs: facteursHtml,
    diag_html_conseils: conseilsHtml
  };
  var identifyPayload={data:{type:'profile',attributes:{
    email:email,
    first_name:prenom,
    properties:allProps
  }}};

  // ── EVENT : déclenche le flow "Diagnostic Completed" ──
  // On appelle directement l'API Klaviyo Client Events (pas le SDK window.klaviyo,
  // qui échoue silencieusement quand klaviyo.js n'est pas chargé sur la page).
  allProps.diag_timestamp = new Date().toISOString();

  function ndSendDiagnosticEvent(){
    return fetch('https://a.klaviyo.com/client/events/?company_id=V7ixtx',{
      method:'POST',
      headers:{'Content-Type':'application/json','revision':'2024-10-15'},
      body:JSON.stringify({data:{type:'event',attributes:{
        properties: allProps,
        metric:{data:{type:'metric',attributes:{name:'Diagnostic Completed'}}},
        profile:{data:{type:'profile',attributes:{email:email, first_name:prenom}}}
      }}})
    }).then(function(r){
      console.log('Klaviyo event status:', r.status);
      if(r.status !== 202){
        return r.text().then(function(t){ console.log('Klaviyo event body:', t); });
      }
    }).catch(function(e){
      console.log('Klaviyo event erreur reseau:', e);
    });
  }

  // On met à jour le profil, PUIS on envoie l'événement.
  // Le .catch renvoie aussi vers l'événement pour qu'il parte même si l'update échoue.
  fetch('https://a.klaviyo.com/client/profiles/?company_id=V7ixtx',{
    method:'POST',
    headers:{'Content-Type':'application/json','revision':'2023-02-22'},
    body:JSON.stringify(identifyPayload)
  }).then(ndSendDiagnosticEvent).catch(ndSendDiagnosticEvent);
}

/* ── ROUTINE COMPLETE : calculs et liens ── */
function ndEstOption(p){ return BUNDLE_EXCLUDE.indexOf(p.u)>-1; }
function ndProduitsDuLot(produits){
  return produits.filter(function(p){ return !ndEstOption(p); });
}
function ndPrixNum(p){
  var n=parseFloat(String(p).replace(/[^0-9.,]/g,'').replace(',','.'));
  return isNaN(n)?0:n;
}
function ndEuros(n){
  return n.toFixed(2).replace('.',',')+'\u20ac';
}
function ndRoutineTotaux(produits){
  var total=produits.reduce(function(sum,p){return sum+ndPrixNum(p.p);},0);
  var remise=total*(ROUTINE_PCT/100);
  return {total:total, remise:remise, final:total-remise, n:produits.length};
}
/* Construit un lien panier pre-rempli avec la remise appliquee.
   Repli sur la page du diagnostic si les variantes sont introuvables. */
function ndBuildCartPermalink(produits,fallbackUrl){
  var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  var jobs=ndProduitsDuLot(produits).map(function(p){
    var handle=p.u.split('/').pop();
    return fetch(root+'products/'+handle+'.js',{headers:{'Accept':'application/json'},credentials:'same-origin'})
      .then(function(r){ if(!r.ok) throw new Error(handle); return r.json(); })
      .then(function(prod){
        var vs=prod.variants||[];
        var v=vs.filter(function(x){return x.available;})[0]||vs[0];
        if(!v) throw new Error('variante '+handle);
        return v.id+':1';
      });
  });
  var timeout=new Promise(function(_,rej){setTimeout(function(){rej(new Error('timeout'));},2500);});
  return Promise.race([Promise.all(jobs),timeout])
    .then(function(parts){
      var url=SHOP_ORIGIN+'/cart/'+parts.join(',');
      return ROUTINE_AUTO?url:(url+'?discount='+ROUTINE_CODE);
    })
    .catch(function(e){
      console.log('[Routine] lien panier indisponible, repli :',e.message||e);
      return fallbackUrl||SHOP_ORIGIN+'/collections/les-essentiels';
    });
}

function has(id,val){
  var arr=NA[id]||[];
  if(!Array.isArray(arr)) arr=[arr];
  return arr.indexOf(val)>-1;
}

function hasAny(id,vals){
  return vals.some(function(v){return has(id,v);});
}

/* ── SCORES DYNAMIQUES ── */
function ndCalcScores(baseScores){
  var scores={};
  var keys=Object.keys(baseScores);
  keys.forEach(function(k){ scores[k]=baseScores[k]; });

  // Ajustements selon réponses réelles
  if(has('alimentation','pro_inflammatoire')){
    keys.forEach(function(k){ scores[k]=Math.max(5,scores[k]-5); });
  }
  if(has('alimentation','anti_inflammatoire')){
    keys.forEach(function(k){ scores[k]=Math.min(95,scores[k]+5); });
  }
  if(has('spf','spf_50')){
    if(scores['Protection']!==undefined) scores['Protection']=Math.min(95,scores['Protection']+15);
    if(scores['Pr\u00e9vention']!==undefined) scores['Pr\u00e9vention']=Math.min(95,scores['Pr\u00e9vention']+10);
  }
  if(has('spf','spf_non')){
    if(scores['Protection']!==undefined) scores['Protection']=Math.max(5,scores['Protection']-15);
    if(scores['Pr\u00e9vention']!==undefined) scores['Pr\u00e9vention']=Math.max(5,scores['Pr\u00e9vention']-10);
  }
  if(has('mode_de_vie','stress')){
    keys.forEach(function(k){ scores[k]=Math.max(5,scores[k]-3); });
  }
  if(has('nettoyage','doux')){
    if(scores['Barri\u00e8re']!==undefined) scores['Barri\u00e8re']=Math.min(95,scores['Barri\u00e8re']+10);
  }
  if(hasAny('nettoyage',['agressif','sls'])){
    if(scores['Barri\u00e8re']!==undefined) scores['Barri\u00e8re']=Math.max(5,scores['Barri\u00e8re']-10);
  }
  return scores;
}

/* ── MESSAGE OBJECTIF ── */
function ndObjectifMsg(){
  var parts=[];
  if(has('objectif','eclat')) parts.push('retrouver un teint lumineux');
  if(has('objectif','imperfections')) parts.push('r\u00e9duire les imperfections');
  if(has('objectif','hydratation')) parts.push('hydrater durablement');
  if(has('objectif','taches')) parts.push('unifier le teint');
  if(has('objectif','antiage')) parts.push('pr\u00e9venir les signes du temps');
  if(parts.length===0) return '';
  if(parts.length===1) return 'Votre objectif prioritaire : '+parts[0]+'. ';
  return 'Vos objectifs : '+parts.slice(0,-1).join(', ')+' et '+parts[parts.length-1]+'. ';
}

/* ── MESSAGE ROUTINE ACTUELLE ── */
function ndRoutineMsg(){
  if(has('routine_actuelle','zero')) return 'Vous partez de z\u00e9ro : commencez par un seul produit pendant 2 semaines avant d\'en ajouter un second. Votre peau a besoin de s\'adapter progressivement.';
  if(has('routine_actuelle','complexe')) return 'Votre routine actuelle est complexe (6+ produits). Nous vous recommandons de simplifier : arr\u00eatez tout sauf un nettoyant doux, puis r\u00e9introduisez un produit toutes les 2 semaines.';
  return '';
}

function ndShowResults(){
  // Fallback pour les URLs partagées (pas d'email)
  var resultData = ndComputeResults();
  ndRenderResults(resultData);
}

function ndComputeResults(){
  var pn=NPRENOM;

  var isGrasse=has('type','grasse');
  var isMixte=has('type','mixte')||has('type','mixte_deshydratee');
  var isSeche=has('type','seche');
  var isMixteDeshy=has('type','mixte_deshydratee');
  var isNormale=has('type','normale');
  var isTresSensible=has('sensibilite','tres_sensible');
  var isSensible=has('sensibilite','sensible')||isTresSensible;
  var barriereFragilisee=has('hydratation','barriere_alteree')||has('hydratation','barriere_fragilisee');
  var hasAcne=hasAny('imperfections',['inflammatoire','comedons','kystique','hormonal','stress_acne']);
  var hasAcneInflamm=has('imperfections','inflammatoire')||has('imperfections','kystique');
  var hasTaches=hasAny('taches',['taches_solaires','melasma','post_acne']);
  var hasMelasma=has('taches','melasma');
  var isMature=has('age','plus45');
  var is35_45=has('age','35_45');
  var is25_35=has('age','25_35');
  var isMoins25=has('age','moins25');
  var isInflammSys=(has('mode_de_vie','stress')&&has('alimentation','pro_inflammatoire'))||(has('imperfections','inflammatoire')&&has('alimentation','pro_inflammatoire'));
  var isNettoyageAgressif=hasAny('nettoyage',['agressif','sls','micellaire']);
  var wantsAntiage=has('objectif','antiage');
  var wantsEclat=has('objectif','eclat');

  var profil,desc,mecanisme='',produits=[],routine=[],facteurs=[],alertes=[],conseils=[],baseScores={};

  if(isMixteDeshy){
    profil='Peau mixte d\u00e9shydrat\u00e9e';
    desc=(pn?pn+', votre':'Votre')+' peau pr\u00e9sente le profil le plus mal compris en cosm\u00e9tique : grasse en zone T et d\u00e9shydrat\u00e9e sur les joues simultan\u00e9ment. Ce n\'est pas contradictoire, c\'est une barri\u00e8re cutan\u00e9e d\u00e9r\u00e9gl\u00e9e qui produit du s\u00e9bum en r\u00e9action d\u00e9fensive au manque d\'eau. '+ndObjectifMsg()+'La cl\u00e9 : hydrater sans occlure.';
    mecanisme='La zone T produit du s\u00e9bum car la barri\u00e8re hydrolipidique est compromise. Plus la peau perd de l\'eau, plus elle compense avec du s\u00e9bum. Le S\u00e9rum Hydratant Noc\u00e9e apporte les humectants n\u00e9cessaires pour casser ce cercle vicieux.';
    produits=[
      {n:'S\u00e9rum Hydratant Booster',a:'AH multi-poids + Panthenol + Glyc\u00e9rine',d:'R\u00e9hydrate sans alourdir, casse le cercle vicieux s\u00e9bum/d\u00e9shydratation',u:'/products/serum-hydratant',p:'22\u20ac',star:true,ordre:'Matin et soir, sur peau l\u00e9g\u00e8rement humide'},
      {n:'Poudre Nettoyante Exfoliante 2-en-1',a:'SCI + Enzymes de Papaye + Kaolin',d:'Nettoie la zone T sans d\u00e9caper les joues',u:'/products/poudre-nettoyante-et-exfoliante',p:'21\u20ac',ordre:POUDRE_ORDRE}
    ];
    if(hasTaches) produits.push({n:'S\u00e9rum Unifiant Anti-T\u00e2ches',a:'Acide Tranexamique 3%',d:'Soir uniquement sur zones \u00e0 taches',u:'/products/serum-anti-taches',p:'22\u20ac',ordre:'Soir : en premier sur peau s\u00e8che, avant le S\u00e9rum Hydratant'});
    routine=[
      {m:'Matin',s:['Rin\u00e7age \u00e0 l\'eau ti\u00e8de ou fra\u00eeche, pas de nettoyant le matin.','S\u00e9rum Hydratant Booster, 3 \u00e0 4 gouttes sur peau encore humide. Tapoter, ne pas frotter.','SPF 50 texture l\u00e9g\u00e8re non com\u00e9dog\u00e8ne, ne pas omettre la zone T.']},
      {m:'Soir (ordre pr\u00e9cis)',s:[POUDRE_SOIR,hasTaches?'S\u00e9rum Anti-T\u00e2ches, sur peau propre et s\u00e8che. Attendre 5 minutes.':'S\u00e9rum Hydratant Booster, application g\u00e9n\u00e9reuse en tapotant.',hasTaches?'Cr\u00e8me hydratante l\u00e9g\u00e8re, appliquer pour sceller le s\u00e9rum actif.':''].filter(Boolean)}
    ];
    conseils=[
      {icon:'',t:'Appliquer le s\u00e9rum sur peau encore humide',d:'L\'humidit\u00e9 r\u00e9siduelle am\u00e9liore l\'absorption des actifs humectants de 40%. Ne pas attendre que la peau soit compl\u00e8tement s\u00e8che.'},
      {icon:'',t:'Pas de nettoyant le matin',d:'Le matin, un simple rin\u00e7age \u00e0 l\'eau fra\u00eeche suffit. Le nettoyant est r\u00e9serv\u00e9 au soir pour retirer le s\u00e9bum et la pollution accumul\u00e9s.'},
    ];
    baseScores={Hydratation:25,\u00c9quilibre:35,Barri\u00e8re:40};

  } else if((isGrasse||isMixte)&&hasAcneInflamm&&isSensible){
    profil='Peau acn\u00e9ique inflammatoire sensible';
    desc=(pn?pn+', votre':'Votre')+' peau combine acn\u00e9 inflammatoire active et hyperr\u00e9activit\u00e9. '+ndObjectifMsg()+'C\'est le profil qui n\u00e9cessite le plus de pr\u00e9caution. Le protocole Noc\u00e9e privil\u00e9gie le Zinc PCA, anti-inflammatoire et r\u00e9gulateur doux, sans irriter.';
    mecanisme='L\'inflammation cutan\u00e9e amplifie la r\u00e9ponse immunitaire locale. Priorit\u00e9 absolue : calmer avant de traiter. Le Zinc PCA inhibe la production de s\u00e9bum sans effet rebond et r\u00e9duit l\'inflammation sans d\u00e9caper.';
    produits=[
      {n:'S\u00e9rum R\u00e9gulateur S\u00e9bum',a:'Zinc PCA + AHA doux + Niacinamide',d:'R\u00e9gule sans irriter, en premier sur peau propre et s\u00e8che',u:'/products/serum-regulateur-sebum-zinc-pca',p:'22\u20ac',star:true,ordre:'\u00c9tape 1 : sur peau propre et s\u00e8che'},
      {n:'S\u00e9rum Hydratant Booster',a:'Panthenol + AH multi-poids',d:'Apporte l\'hydratation sans alourdir, par-dessus le s\u00e9rum actif',u:'/products/serum-hydratant',p:'22\u20ac',ordre:'\u00c9tape 2 : apr\u00e8s le S\u00e9rum R\u00e9gulateur sec'},
      {n:'Poudre Nettoyante Exfoliante 2-en-1',a:'SCI + Sorbitol',d:'Le tensioactif le plus doux, respecte les l\u00e9sions actives',u:'/products/poudre-nettoyante-et-exfoliante',p:'21\u20ac',ordre:POUDRE_ORDRE}
    ];
    routine=[
      {m:'Matin',s:['Rin\u00e7age \u00e0 l\'eau fra\u00eeche uniquement, pas de nettoyant le matin.','S\u00e9rum R\u00e9gulateur, 2 \u00e0 3 gouttes sur peau s\u00e8che. \u00c9viter les l\u00e9sions ouvertes.','Cr\u00e8me hydratante l\u00e9g\u00e8re, appliquer pour sceller le s\u00e9rum actif.','SPF 50 texture gel non com\u00e9dog\u00e8ne.']},
      {m:'Soir',s:[POUDRE_SOIR,'S\u00e9rum R\u00e9gulateur, sur peau parfaitement s\u00e8che (attendre 3 min apr\u00e8s nettoyage).','Cr\u00e8me hydratante l\u00e9g\u00e8re, appliquer pour sceller le s\u00e9rum actif.','Pas de cr\u00e8me grasse. Pas d\'occlusion sur acn\u00e9 active.']}
    ];
    alertes=[{t:'Introduire un seul produit \u00e0 la fois',d:'Tester chaque nouveau produit 48h sur la face interne du poignet avant le visage. Ne jamais superposer deux actifs nouveaux simultan\u00e9ment.'}];
    conseils=[
      {icon:'',t:'Un produit \u00e0 la fois',d:'Attendre 2 semaines avant d\'ajouter un nouveau soin. Votre peau r\u00e9active a besoin de temps pour s\'adapter.'},
      {icon:'',t:'Changer la taie d\'oreiller tous les 2 jours',d:'Les bact\u00e9ries s\'accumulent sur le tissu et alimentent l\'inflammation pendant le sommeil.'},
    ];
    baseScores={Inflammation:20,S\u00e9bum:30,Sensibilit\u00e9:50};

  } else if((isGrasse||isMixte)&&hasAcne&&hasTaches){
    profil='Peau acn\u00e9ique avec s\u00e9quelles pigmentaires';
    desc=(pn?pn+', votre':'Votre')+' peau g\u00e8re simultan\u00e9ment des imperfections actives et les traces qu\'elles laissent. '+ndObjectifMsg()+'Le protocole traite les deux en s\u00e9quence pour \u00e9viter toute interaction contre-productive entre les actifs.';
    mecanisme='L\'hyperpigmentation post-inflammatoire est caus\u00e9e par une suractivation des m\u00e9lanocytes suite \u00e0 l\'acn\u00e9. R\u00e9duire l\'inflammation en priorit\u00e9 r\u00e9duit aussi les traces futures. L\'acide tranexamique est appliqu\u00e9 soir uniquement, sur zones cicatris\u00e9es.';
    produits=[
      {n:'S\u00e9rum R\u00e9gulateur S\u00e9bum',a:'Zinc PCA + AHA doux',d:'\u00c9tape 1 soir : imperfections actives',u:'/products/serum-regulateur-sebum-zinc-pca',p:'22\u20ac',star:true,ordre:'\u00c9tape 1 soir : sur peau propre et s\u00e8che'},
      {n:'S\u00e9rum Unifiant Anti-T\u00e2ches',a:'Acide Tranexamique 3%',d:'\u00c9tape 2 soir : zones cicatris\u00e9es uniquement',u:'/products/serum-anti-taches',p:'22\u20ac',ordre:'\u00c9tape 2 soir : sur zones cicatris\u00e9es, apr\u00e8s S\u00e9rum R\u00e9gulateur sec'},
      {n:'S\u00e9rum Hydratant Booster',a:'Panthenol + AH multi-poids',d:'\u00c9tape 3 : scelle et hydrate par-dessus les actifs',u:'/products/serum-hydratant',p:'22\u20ac',ordre:'\u00c9tape 3 : en dernier, pour sceller les actifs'},
      {n:'Poudre Nettoyante Exfoliante 2-en-1',a:'SCI + Papain + Kaolin',d:'Exfoliation enzymatique douce',u:'/products/poudre-nettoyante-et-exfoliante',p:'21\u20ac',ordre:POUDRE_ORDRE}
    ];
    routine=[
      {m:'Matin',s:['Rin\u00e7age \u00e0 l\'eau fra\u00eeche, pas de nettoyant le matin.','S\u00e9rum R\u00e9gulateur, sur peau s\u00e8che. Laisser p\u00e9n\u00e9trer 5 minutes.','Cr\u00e8me hydratante l\u00e9g\u00e8re, appliquer pour sceller.','SPF 50+ : CRITIQUE. L\'exposition solaire aggrave les traces de fa\u00e7on irr\u00e9versible.']},
      {m:'Soir (ordre pr\u00e9cis)',s:[POUDRE_SOIR,'S\u00e9rum R\u00e9gulateur, sur peau propre et s\u00e8che. Laisser p\u00e9n\u00e9trer 5 minutes.','S\u00e9rum Anti-T\u00e2ches, uniquement sur les traces et zones cicatris\u00e9es. Attendre 5 minutes.','Cr\u00e8me hydratante l\u00e9g\u00e8re, appliquer pour sceller.']}
    ];
    conseils=[
      {icon:'',t:'Ne jamais toucher ni percer les boutons',d:'Percer une l\u00e9sion aggrave l\'inflammation et multiplie le risque de trace pigmentaire persistante.'},
      {icon:'',t:'R\u00e9duire le sucre raffin\u00e9',d:'L\'index glyc\u00e9mique \u00e9lev\u00e9 stimule l\'insuline qui active directement la production de s\u00e9bum.'},
    ];
    baseScores={S\u00e9bum:20,Inflammation:30,Pigmentation:50};

  } else if((isGrasse||isMixte)&&hasAcne){
    profil='Peau grasse \u00e0 tendance acn\u00e9ique';
    desc=(pn?pn+', votre':'Votre')+' peau produit un exc\u00e8s de s\u00e9bum entra\u00eenant brillances, pores dilat\u00e9s et imperfections r\u00e9currentes. '+ndObjectifMsg()+'L\'erreur la plus fr\u00e9quente : utiliser des produits d\u00e9capants qui aggravent la production s\u00e9bac\u00e9e en r\u00e9ponse d\u00e9fensive.';
    mecanisme='Le Zinc PCA inhibe la 5\u03b1-r\u00e9ductase, l\'enzyme qui stimule la production de s\u00e9bum, sans cr\u00e9er d\'effet rebond. R\u00e9sultat : r\u00e9gulation durable sans dess\u00e8chement.';
    produits=[
      {n:'S\u00e9rum R\u00e9gulateur S\u00e9bum',a:'Zinc PCA + AHA doux + Niacinamide',d:'R\u00e9gulation s\u00e9bac\u00e9e sans dess\u00e9cher, \u00e9tape 1',u:'/products/serum-regulateur-sebum-zinc-pca',p:'22\u20ac',star:true,ordre:'\u00c9tape 1 : sur peau propre et s\u00e8che'},
      {n:'S\u00e9rum Hydratant Booster',a:'AH multi-poids + Panthenol',d:'Hydratation l\u00e9g\u00e8re, \u00e9tape 2 par-dessus le s\u00e9rum actif',u:'/products/serum-hydratant',p:'22\u20ac',ordre:'\u00c9tape 2 : apr\u00e8s le S\u00e9rum R\u00e9gulateur sec'},
      {n:'Poudre Nettoyante Exfoliante 2-en-1',a:'SCI + Papain + Kaolin',d:'Absorbe l\'exc\u00e8s de s\u00e9bum, exfoliation enzymatique douce',u:'/products/poudre-nettoyante-et-exfoliante',p:'21\u20ac',ordre:POUDRE_ORDRE}
    ];
    routine=[
      {m:'Matin',s:['Rin\u00e7age \u00e0 l\'eau fra\u00eeche, pas de nettoyant le matin.','S\u00e9rum R\u00e9gulateur, 3 gouttes sur peau s\u00e8che. Tapoter.','Cr\u00e8me hydratante l\u00e9g\u00e8re, appliquer pour sceller le s\u00e9rum actif.','SPF 50 texture gel ou fluide non com\u00e9dog\u00e8ne.']},
      {m:'Soir',s:[POUDRE_SOIR,'S\u00e9rum R\u00e9gulateur, sur peau propre et s\u00e8che. Laisser p\u00e9n\u00e9trer 5 minutes.','Cr\u00e8me hydratante l\u00e9g\u00e8re, appliquer pour sceller.','Pas de cr\u00e8me grasse. Pas d\'occlusion suppl\u00e9mentaire.']}
    ];
    conseils=[
      {icon:'',t:'Rin\u00e7age \u00e0 l\'eau fra\u00eeche le matin',d:'L\'eau fra\u00eeche resserre les pores et ne perturbe pas le s\u00e9bum naturel du matin. Pas de nettoyant le matin.'},
      {icon:'',t:'Changer la taie d\'oreiller r\u00e9guli\u00e8rement',d:'Les r\u00e9sidus s\u00e9bac\u00e9s s\'accumulent sur le tissu et r\u00e9alimentent l\'obstruction des pores chaque nuit.'},
    ];
    baseScores={S\u00e9bum:25,\u00c9quilibre:35,Sant\u00e9:40};

  /* ── NOUVEAU PROFIL : grasse/mixte SANS acné ── */
  } else if((isGrasse||isMixte)&&!hasAcne){
    profil='Peau grasse ou mixte \u00e0 r\u00e9guler';
    desc=(pn?pn+', votre':'Votre')+' peau produit un exc\u00e8s de s\u00e9bum sans imperfections actives. '+ndObjectifMsg()+'Le Zinc PCA r\u00e9gule la production s\u00e9bac\u00e9e en douceur, sans ass\u00e9cher ni d\u00e9clencher d\'effet rebond. Votre peau n\'a pas besoin d\'\u00eatre d\u00e9cap\u00e9e, elle a besoin d\'\u00eatre r\u00e9\u00e9quilibr\u00e9e.';
    mecanisme='M\u00eame sans acn\u00e9, l\'exc\u00e8s de s\u00e9bum alt\u00e8re la qualit\u00e9 du film hydrolipidique et dilate les pores. Le Zinc PCA normalise la production sans effet rebond, tandis que la Niacinamide resserre les pores visibles.';
    produits=[
      {n:'S\u00e9rum R\u00e9gulateur S\u00e9bum',a:'Zinc PCA + AHA doux + Niacinamide',d:'R\u00e9gulation s\u00e9bac\u00e9e sans dess\u00e9cher',u:'/products/serum-regulateur-sebum-zinc-pca',p:'22\u20ac',star:true,ordre:'Matin et soir, sur peau propre et s\u00e8che'},
      {n:'S\u00e9rum Hydratant Booster',a:'AH multi-poids + Panthenol',d:'Hydratation l\u00e9g\u00e8re par-dessus le s\u00e9rum r\u00e9gulateur',u:'/products/serum-hydratant',p:'22\u20ac',ordre:'Matin et soir, apr\u00e8s le S\u00e9rum R\u00e9gulateur sec'},
      {n:'Poudre Nettoyante Exfoliante 2-en-1',a:'SCI + Papain + Kaolin',d:'Nettoie et absorbe le s\u00e9bum sans agresser',u:'/products/poudre-nettoyante-et-exfoliante',p:'21\u20ac',ordre:POUDRE_ORDRE}
    ];
    if(hasTaches) produits.push({n:'S\u00e9rum Unifiant Anti-T\u00e2ches',a:'Acide Tranexamique 3%',d:'Soir uniquement sur zones pigment\u00e9es',u:'/products/serum-anti-taches',p:'22\u20ac',ordre:'Soir : en premier avant le S\u00e9rum R\u00e9gulateur'});
    routine=[
      {m:'Matin',s:['Rin\u00e7age \u00e0 l\'eau fra\u00eeche, pas de nettoyant le matin.','S\u00e9rum R\u00e9gulateur, 3 gouttes sur peau s\u00e8che.','S\u00e9rum Hydratant Booster, par-dessus, sur peau l\u00e9g\u00e8rement humide.','SPF 50 texture fluide non com\u00e9dog\u00e8ne.']},
      {m:'Soir',s:[POUDRE_SOIR,hasTaches?'S\u00e9rum Anti-T\u00e2ches, en premier sur peau propre et s\u00e8che.':'S\u00e9rum R\u00e9gulateur, sur peau propre et s\u00e8che.','S\u00e9rum Hydratant Booster, en dernier pour sceller.']}
    ];
    conseils=[
      {icon:'',t:'Rin\u00e7age \u00e0 l\'eau fra\u00eeche le matin',d:'L\'eau fra\u00eeche resserre les pores sans perturber le film lipidique naturel.'},
      {icon:'',t:'\u00c9viter les textures grasses et occlusives',d:'Privil\u00e9giez les textures gel ou fluide. Les cr\u00e8mes riches surchargent une peau qui produit d\u00e9j\u00e0 du s\u00e9bum.'},
    ];
    baseScores={S\u00e9bum:30,\u00c9quilibre:40,\u00c9clat:30};

  } else if(hasMelasma){
    profil='Peau avec m\u00e9lasma ou hyperm\u00e9lanose hormonale';
    desc=(pn?pn+', votre':'Votre')+' peau pr\u00e9sente du m\u00e9lasma, les taches les plus complexes \u00e0 traiter. '+ndObjectifMsg()+'L\'acide tranexamique est l\'actif le mieux tol\u00e9r\u00e9 disponible. Mais sans SPF 50+ quotidien, aucun actif ne peut fonctionner.';
    mecanisme='Le m\u00e9lasma est d\u00e9clench\u00e9 par les \u0153strog\u00e8nes et amplifi\u00e9 par les UV. L\'acide tranexamique inhibe le signal de production de m\u00e9lanine. Il doit \u00eatre appliqu\u00e9 le soir uniquement, apr\u00e8s le S\u00e9rum Hydratant.';
    produits=[
      {n:'S\u00e9rum Unifiant Anti-T\u00e2ches',a:'Acide Tranexamique 3%',d:'Actif de r\u00e9f\u00e9rence pour le m\u00e9lasma, soir uniquement',u:'/products/serum-anti-taches',p:'22\u20ac',star:true,ordre:'\u00c9tape 1 soir : sur peau propre et s\u00e8che'},
      {n:'S\u00e9rum Hydratant Booster',a:'Panthenol + AH + Tasmannia antioxydant',d:'Hydratation essentielle, matin avant SPF',u:'/products/serum-hydratant',p:'22\u20ac',ordre:'Matin : avant SPF 50+ \u00b7 Soir : apr\u00e8s S\u00e9rum Anti-T\u00e2ches sec'},
      {n:'Poudre Nettoyante Exfoliante 2-en-1',a:'Enzymes de Papaye',d:'Exfoliation enzymatique l\u00e9g\u00e8re',u:'/products/poudre-nettoyante-et-exfoliante',p:'21\u20ac',ordre:POUDRE_ORDRE}
    ];
    routine=[
      {m:'Matin',s:['Rin\u00e7age \u00e0 l\'eau ti\u00e8de, pas de nettoyant le matin.','S\u00e9rum Hydratant Booster, 3 gouttes sur peau l\u00e9g\u00e8rement humide.','SPF 50+ large spectre UVA/UVB : APPLICATION OBLIGATOIRE. Renouveler toutes les 2h en ext\u00e9rieur.']},
      {m:'Soir (ordre pr\u00e9cis)',s:[POUDRE_SOIR,'S\u00e9rum Anti-T\u00e2ches, sur peau propre et s\u00e8che. Attendre 5 minutes.','Cr\u00e8me hydratante l\u00e9g\u00e8re, appliquer pour sceller le s\u00e9rum actif.']}
    ];
    alertes=[{t:'SPF 50+ = 80% du traitement du m\u00e9lasma',d:'Sans SPF 50+ appliqu\u00e9 chaque matin, l\'acide tranexamique du soir est contre-productif. Les UVA re-stimulent les m\u00e9lanocytes le jour m\u00eame. Pas d\'exception.'}];
    conseils=[
      {icon:'',t:'Porter un chapeau \u00e0 larges bords en ext\u00e9rieur',d:'Le SPF seul ne suffit pas lors d\'exposition prolong\u00e9e. Un chapeau r\u00e9duit de 70% les UV atteignant le visage.'},
      {icon:'',t:'\u00c9viter la chaleur excessive',d:'Sauna, bain tr\u00e8s chaud : la chaleur stimule les m\u00e9lanocytes et aggrave le m\u00e9lasma.'},
    ];
    baseScores={Pigmentation:20,Protection:30,Traitement:50};

  } else if(hasTaches&&!hasAcne){
    profil='Peau avec hyperpigmentation solaire';
    desc=(pn?pn+', votre':'Votre')+' peau pr\u00e9sente des taches d\'origine photique. '+ndObjectifMsg()+'L\'acide tranexamique \u00e0 3% est l\'actif d\u00e9pigmentant le plus stable et le mieux tol\u00e9r\u00e9 disponible.';
    mecanisme='L\'acide tranexamique inhibe la liaison entre les k\u00e9ratinocytes UV-activ\u00e9s et les m\u00e9lanocytes, r\u00e9duisant le signal pro-m\u00e9lanog\u00e9nique \u00e0 la source. Il doit \u00eatre appliqu\u00e9 en premier le soir sur peau propre et s\u00e8che.';
    produits=[
      {n:'S\u00e9rum Unifiant Anti-T\u00e2ches',a:'Acide Tranexamique 3%',d:'\u00c9tape 1 soir : en premier sur peau propre et s\u00e8che',u:'/products/serum-anti-taches',p:'22\u20ac',star:true,ordre:'\u00c9tape 1 soir : sur peau propre et s\u00e8che'},
      {n:'S\u00e9rum Hydratant Booster',a:'Panthenol + AH multi-poids + Tasmannia',d:'Matin avant SPF \u00b7 Soir apr\u00e8s S\u00e9rum Anti-T\u00e2ches sec',u:'/products/serum-hydratant',p:'22\u20ac',ordre:'Matin : avant SPF 50+ \u00b7 Soir : apr\u00e8s S\u00e9rum Anti-T\u00e2ches sec'},
      {n:'Poudre Nettoyante Exfoliante 2-en-1',a:'Enzymes de Papaye',d:'Exfoliation enzymatique, am\u00e9liore la p\u00e9n\u00e9tration de l\'actif',u:'/products/poudre-nettoyante-et-exfoliante',p:'21\u20ac',ordre:POUDRE_ORDRE}
    ];
    routine=[
      {m:'Matin',s:['Rin\u00e7age \u00e0 l\'eau ti\u00e8de.','S\u00e9rum Hydratant Booster, 3 gouttes sur peau l\u00e9g\u00e8rement humide.','SPF 50+, obligatoire. Sans lui, l\'acide tranexamique du soir est annul\u00e9 par les UV du matin.']},
      {m:'Soir (ordre pr\u00e9cis)',s:[POUDRE_SOIR,'S\u00e9rum Anti-T\u00e2ches, en premier sur peau propre et s\u00e8che. Attendre 5 minutes.','Cr\u00e8me hydratante l\u00e9g\u00e8re, appliquer pour sceller le s\u00e9rum actif.']}
    ];
    conseils=[
      {icon:'',t:'Renouveler le SPF 50 toutes les 2h en ext\u00e9rieur',d:'Une seule application le matin ne suffit pas lors d\'exposition prolong\u00e9e.'},
      {icon:'',t:'Alimentation antioxydante',d:'Baies, l\u00e9gumes verts, th\u00e9 vert : les antioxydants alimentaires compl\u00e8tent la protection contre les dommages UV.'},
    ];
    baseScores={Pigmentation:20,\u00c9clat:30,Protection:50};

  } else if(isSeche&&isSensible&&barriereFragilisee){
    profil='Peau s\u00e8che \u00e0 barri\u00e8re cutan\u00e9e alt\u00e9r\u00e9e';
    desc=(pn?pn+', votre':'Votre')+' peau pr\u00e9sente une barri\u00e8re hydrolipidique d\u00e9ficiente. '+ndObjectifMsg()+'C\'est une condition qui n\u00e9cessite une reconstruction progressive avant d\'introduire tout actif correcteur.';
    mecanisme='Le Panthenol (provitamine B5) stimule la synth\u00e8se de c\u00e9ramides endog\u00e8nes, reconstituant progressivement la barri\u00e8re. \u00c0 ce stade, la priorit\u00e9 absolue est la reconstruction, pas la correction.';
    produits=[
      {n:'S\u00e9rum Hydratant Booster',a:'Panthenol 5% + AH multi-poids + Tasmannia + Glyc\u00e9rine',d:'Reconstruction de la barri\u00e8re, seul produit actif n\u00e9cessaire pour commencer',u:'/products/serum-hydratant',p:'22\u20ac',star:true,ordre:'Matin et soir, sur peau encore humide'},
      {n:'Poudre Nettoyante Exfoliante 2-en-1',a:'SCI + Sorbitol hydratant',d:'SCI pr\u00e9serve les lipides cutan\u00e9s existants',u:'/products/poudre-nettoyante-et-exfoliante',p:'21\u20ac',ordre:POUDRE_ORDRE}
    ];
    routine=[
      {m:'Matin',s:['Rin\u00e7age \u00e0 l\'eau ti\u00e8de ou fra\u00eeche, tamponner sans frotter.','S\u00e9rum Hydratant Booster, imm\u00e9diatement sur peau encore humide. Tapoter.','SPF 50 texture l\u00e9g\u00e8re. Laisser s\u00e9cher entre chaque \u00e9tape.']},
      {m:'Soir',s:[POUDRE_SOIR,'S\u00e9rum Hydratant Booster, application g\u00e9n\u00e9reuse en tapotant.','Cr\u00e8me riche avec c\u00e9ramides si n\u00e9cessaire, uniquement par-dessus le s\u00e9rum sec.']}
    ];
    alertes=[{t:'Ne pas introduire de nouveaux actifs avant 4 semaines',d:'Une barri\u00e8re alt\u00e9r\u00e9e absorbe les actifs de fa\u00e7on impr\u00e9visible. Stabiliser la barri\u00e8re d\'abord, corriger ensuite.'}];
    conseils=[
      {icon:'',t:'Eau ti\u00e8de uniquement, jamais chaude',d:'L\'eau chaude dissout les lipides de surface et aggrave la perm\u00e9abilit\u00e9 de la barri\u00e8re. 30\u00b0C maximum.'},
      {icon:'',t:'Patience, 4 semaines minimum',d:'La reconstruction de la barri\u00e8re prend du temps. Ne pas ajouter de nouveaux actifs avant stabilisation.'},
    ];
    baseScores={Barri\u00e8re:20,Hydratation:25,R\u00e9paration:55};

  } else if(isSeche){
    profil='Peau s\u00e8che \u00e0 d\u00e9shydrat\u00e9e';
    desc=(pn?pn+', votre':'Votre')+' peau manque de lipides et/ou d\'eau. '+ndObjectifMsg()+'Le Panthenol + acide hyaluronique multi-poids couvre les deux cas simultan\u00e9ment.';
    mecanisme='L\'AH bas poids mol\u00e9culaire hydrate en profondeur, le haut poids mol\u00e9culaire prot\u00e8ge en surface. Le Panthenol stimule la synth\u00e8se de c\u00e9ramides. La glyc\u00e9rine capte l\'humidit\u00e9 ambiante.';
    produits=[
      {n:'S\u00e9rum Hydratant Booster',a:'AH multi-poids + Panthenol + Glyc\u00e9rine + Tasmannia',d:'Hydratation profonde multicouche, sur peau humide',u:'/products/serum-hydratant',p:'22\u20ac',star:true,ordre:'Matin et soir, sur peau encore humide'},
      {n:'Poudre Nettoyante Exfoliante 2-en-1',a:'SCI + Sorbitol',d:'Nettoie sans perturber le film hydrolipidique',u:'/products/poudre-nettoyante-et-exfoliante',p:'21\u20ac',ordre:POUDRE_ORDRE}
    ];
    routine=[
      {m:'Matin',s:['Rin\u00e7age \u00e0 l\'eau ti\u00e8de. Tamponner sans frotter.','S\u00e9rum Hydratant Booster, imm\u00e9diatement sur peau humide (moins de 60 secondes apr\u00e8s rin\u00e7age).','SPF 50, les UV aggravent la d\u00e9shydratation cutan\u00e9e.']},
      {m:'Soir',s:[POUDRE_SOIR,'S\u00e9rum Hydratant Booster, plus g\u00e9n\u00e9reusement qu\'au matin.','Cr\u00e8me riche ou baume si n\u00e9cessaire, en dernier geste.']}
    ];
    conseils=[
      {icon:'',t:'Eau ti\u00e8de uniquement, jamais chaude',d:'L\'eau chaude dissout les lipides de surface et aggrave la s\u00e9cheresse. 30\u00b0C maximum.'},
      {icon:'',t:'Humidificateur en hiver',d:'L\'air sec des int\u00e9rieurs chauff\u00e9s aggrave la d\u00e9shydratation. Un humidificateur maintient un taux d\'humidit\u00e9 optimal.'},
    ];
    baseScores={Hydratation:20,Barri\u00e8re:30,Confort:50};

  } else if(isMature){
    profil='Peau mature, remodelage cellulaire ralenti';
    desc=(pn?pn+', votre':'Votre')+' peau entre dans une phase de ralentissement du renouvellement cellulaire. '+ndObjectifMsg()+'Les priorit\u00e9s : hydratation profonde, protection antioxydante et SPF 50 sans compromis.';
    mecanisme='Apr\u00e8s 45 ans, le renouvellement cellulaire passe de 21 \u00e0 35 jours. La production de collag\u00e8ne diminue de 1% par an. L\'AH cutan\u00e9 diminue de 75% entre 20 et 50 ans.';
    produits=[
      {n:'S\u00e9rum Hydratant Booster',a:'AH multi-poids + Panthenol + Tasmannia',d:'Hydratation profonde multicouche, matin et soir',u:'/products/serum-hydratant',p:'22\u20ac',star:true,ordre:'Matin et soir, sur peau l\u00e9g\u00e8rement humide'},
      {n:'Poudre Nettoyante Exfoliante 2-en-1',a:'Enzymes de Papaye + SCI',d:'Exfoliation enzymatique douce, stimule le renouvellement ralenti',u:'/products/poudre-nettoyante-et-exfoliante',p:'21\u20ac',ordre:POUDRE_ORDRE},
      {n:'Growth S\u00e9rum \u00b7 Cils & Sourcils',a:'Growth Ol\u00e9oactif\u00ae brevet\u00e9',d:'+18% de densit\u00e9 des cils en 28 jours, sans prostaglandines',u:'/products/serum-cils-sourcils-growth',p:'34\u20ac',ordre:'Soir : appliquer sur cils et sourcils secs'}
    ];
    if(hasTaches) produits.push({n:'S\u00e9rum Unifiant Anti-T\u00e2ches',a:'Acide Tranexamique 3%',d:'Taches de vieillissement, soir en premier avant S\u00e9rum Hydratant',u:'/products/serum-anti-taches',p:'22\u20ac',ordre:'\u00c9tape 1 soir : avant le S\u00e9rum Hydratant'});
    routine=[
      {m:'Matin',s:['Rin\u00e7age \u00e0 l\'eau ti\u00e8de.','S\u00e9rum Hydratant Booster, 4 \u00e0 5 gouttes. Sur peau humide. Tapoter.','SPF 50+, le principal actif anti-\u00e2ge disponible, sans exception.']},
      {m:'Soir',s:[POUDRE_SOIR,hasTaches?'S\u00e9rum Anti-T\u00e2ches, en premier sur peau s\u00e8che. Attendre 5 minutes.':'S\u00e9rum Hydratant Booster, application g\u00e9n\u00e9reuse.',hasTaches?'Cr\u00e8me hydratante l\u00e9g\u00e8re, appliquer pour sceller le s\u00e9rum actif.':'Cr\u00e8me nuit riche si peau tr\u00e8s s\u00e8che.',hasTaches?'Cr\u00e8me nuit riche si peau tr\u00e8s s\u00e8che.':'','Growth S\u00e9rum, sur cils et sourcils secs, en dernier.'].filter(Boolean)}
    ];
    conseils=[
      {icon:'',t:'Massage du visage quotidien',d:'2 minutes de tapotements stimulent la microcirculation et l\'activit\u00e9 des fibroblastes. \u00c0 faire lors de l\'application du s\u00e9rum.'},
      {icon:'',t:'Prot\u00e9ines et om\u00e9ga-3 suffisants',d:'Le collag\u00e8ne cutan\u00e9 est fabriqu\u00e9 \u00e0 partir des prot\u00e9ines alimentaires. Les om\u00e9ga-3 maintiennent la fluidit\u00e9 des membranes cellulaires.'},
    ];
    baseScores={Hydratation:20,Antioxydant:30,Pr\u00e9vention:50};

  } else {
    profil='Peau \u00e9quilibr\u00e9e';
    desc=(pn?pn+', votre':'Votre')+' peau est globalement \u00e9quilibr\u00e9e. '+ndObjectifMsg()+'Votre enjeu : maintenir cet \u00e9quilibre sur le long terme avec une routine simple et r\u00e9guli\u00e8re. La complexit\u00e9 inutile est le principal ennemi de la peau saine.';
    mecanisme='Une peau \u00e9quilibr\u00e9e maintient un pH cutan\u00e9 stable (5,5), une production s\u00e9bac\u00e9e normale et une barri\u00e8re hydrolipidique intacte. La r\u00e9gularit\u00e9 d\'une routine simple est plus efficace que la complexit\u00e9 d\'une routine irr\u00e9guli\u00e8re.';
    produits=[
      {n:'S\u00e9rum Hydratant Booster',a:'AH multi-poids + Panthenol + Tasmannia',d:'Entretien et hydratation essentielle au quotidien',u:'/products/serum-hydratant',p:'22\u20ac',star:true,ordre:'Matin et soir, sur peau l\u00e9g\u00e8rement humide'},
      {n:'Poudre Nettoyante Exfoliante 2-en-1',a:'Enzymes de Papaye + SCI',d:'Nettoyage et exfoliation douce',u:'/products/poudre-nettoyante-et-exfoliante',p:'21\u20ac',ordre:POUDRE_ORDRE}
    ];
    routine=[
      {m:'Matin',s:['Rin\u00e7age \u00e0 l\'eau fra\u00eeche ou ti\u00e8de.','S\u00e9rum Hydratant Booster, 3 gouttes sur peau l\u00e9g\u00e8rement humide.','SPF 50, protection quotidienne non n\u00e9gociable.']},
      {m:'Soir',s:[POUDRE_SOIR,'S\u00e9rum Hydratant Booster, m\u00eame geste qu\'au matin.','Rien d\'autre sauf besoin sp\u00e9cifique identifi\u00e9.']}
    ];
    conseils=[
      {icon:'',t:'La r\u00e9gularit\u00e9 prime sur tout',d:'Une routine simple appliqu\u00e9e chaque jour est 10 fois plus efficace qu\'une routine complexe appliqu\u00e9e irr\u00e9guli\u00e8rement.'},
      {icon:'',t:'7 \u00e0 8 heures de sommeil',d:'Le renouvellement cellulaire se produit principalement la nuit. Le manque de sommeil ralentit ce processus et ternit le teint.'},
    ];
    baseScores={\u00c9quilibre:25,\u00c9clat:30,Pr\u00e9vention:45};
  }

  /* ── GROWTH SÉRUM : proposé sur TOUS les profils ──
     Le test se fait sur la presence du produit, jamais sur l'age : un profil
     "plus de 45 ans" peut tres bien etre orientee vers une branche grasse ou
     pigmentaire, qui ne contient pas le Growth Serum. */
  var hasGrowth=produits.some(function(p){return p.u==='/products/serum-cils-sourcils-growth';});
  if(!hasGrowth){
    produits.push({n:'Growth S\u00e9rum \u00b7 Cils & Sourcils',a:'Growth Ol\u00e9oactif\u00ae brevet\u00e9',d:'Cils plus denses en 28 jours, +18% de densit\u00e9 mesur\u00e9e, sans prostaglandines. \u00c0 appliquer le soir sur cils et sourcils secs.',u:'/products/serum-cils-sourcils-growth',p:'34\u20ac',ordre:'Soir : sur cils et sourcils secs'});
  }

  /* ── SENSIBILITÉ : alertes et conseils étendus ── */
  if(isTresSensible && profil!=='Peau acn\u00e9ique inflammatoire sensible' && profil!=='Peau s\u00e8che \u00e0 barri\u00e8re cutan\u00e9e alt\u00e9r\u00e9e'){
    alertes.push({t:'Peau tr\u00e8s r\u00e9active d\u00e9tect\u00e9e',d:'Testez chaque nouveau produit 48h sur la face interne du poignet avant application sur le visage. Introduisez un seul produit \u00e0 la fois, avec 2 semaines d\'\u00e9cart minimum.'});
  }
  if(isSensible && !isTresSensible && profil!=='Peau acn\u00e9ique inflammatoire sensible'){
  }

  /* ── TRANCHES D'ÂGE 25-35 et 35-45 ── */
  if(is25_35){
    conseils.push({icon:'',t:'Pr\u00e9vention d\u00e8s maintenant',d:'Les premi\u00e8res fines lignes apparaissent. Le SPF 50 quotidien et l\'hydratation sont vos meilleurs alli\u00e9s anti-\u00e2ge \u00e0 cet \u00e2ge, avant tout actif correcteur.'}); 
  }
  if(is35_45){
    conseils.push({icon:'',t:'Stimuler le renouvellement cellulaire',d:'Le cycle de renouvellement commence \u00e0 ralentir. L\'exfoliation enzymatique r\u00e9guli\u00e8re (Poudre Nettoyante) rel\u00e8ve le teint et am\u00e9liore l\'absorption des actifs.'});
    if(wantsAntiage && !isMature){
      conseils.push({icon:'',t:'Penser regard global',d:'Le Growth S\u00e9rum Cils & Sourcils compl\u00e8te votre approche anti-\u00e2ge, un regard plus dense et d\u00e9fini rajeunit le visage sans chirurgie.'});
    }
  }

  /* ── ROUTINE ACTUELLE ── */
  var routineMsg=ndRoutineMsg();
  if(routineMsg){
    alertes.push({t:has('routine_actuelle','zero')?'Vous partez de z\u00e9ro':'Routine actuelle complexe',d:routineMsg});
  }

  /* ── FACTEURS ── */
  if(has('mode_de_vie','stress')) facteurs.push({t:'Stress chronique, axe neuro-cutan\u00e9',d:'Le cortisol stimule les glandes s\u00e9bac\u00e9es et active l\'inflammation. La peau est le premier organe \u00e0 refl\u00e9ter le stress syst\u00e9mique.'});
  if(has('mode_de_vie','pollution')) facteurs.push({t:'Pollution urbaine, stress oxydatif',d:'Les particules fines PM2.5 p\u00e9n\u00e8trent dans les pores, d\u00e9gradent le collag\u00e8ne et g\u00e9n\u00e8rent des radicaux libres. La Tasmannia du S\u00e9rum Hydratant Booster apporte la protection antioxydante n\u00e9cessaire.'});
  if(has('mode_de_vie','ecran')) facteurs.push({t:'Lumi\u00e8re bleue HEV, photo-vieillissement',d:'La lumi\u00e8re bleue des \u00e9crans g\u00e9n\u00e8re des radicaux libres similaires aux UV. La Tasmannia du S\u00e9rum Hydratant Booster, appliqu\u00e9e le matin, limite ce stress oxydatif.'});
  if(has('mode_de_vie','tabac')) facteurs.push({t:'Tabagisme, vasoconstriction et hypoxie',d:'La nicotine r\u00e9duit l\'oxyg\u00e9nation cutan\u00e9e et d\u00e9grade le collag\u00e8ne plus rapidement que le soleil.'});
  if(has('mode_de_vie','sport')) facteurs.push({t:'Transpiration intense, nettoyage post-effort',d:'La transpiration peut obstruer les pores. Nettoyage doux obligatoire dans les 30 minutes post-effort.'});
  if(has('alimentation','pro_inflammatoire')) facteurs.push({t:'Alimentation pro-inflammatoire, axe intestin-peau',d:'Index glyc\u00e9mique \u00e9lev\u00e9 = pic d\'insuline = stimulation de la production de s\u00e9bum. Le microbiome intestinal influence directement le microbiome cutan\u00e9.'});
  if(isInflammSys) facteurs.push({t:'Inflammation syst\u00e9mique combin\u00e9e',d:'Stress chronique + alimentation pro-inflammatoire amplifient toutes les conditions cutan\u00e9es. Une approche globale est n\u00e9cessaire au-del\u00e0 du soin topique.'});
  if(isNettoyageAgressif) facteurs.push({t:'Protocole de nettoyage inadapt\u00e9',d:'Les nettoyants SLS/SLES et l\'eau micellaire sans rin\u00e7age perturbent le pH cutan\u00e9 et d\u00e9truisent les lipides de la barri\u00e8re.'});
  if(has('routine_actuelle','complexe')) facteurs.push({t:'Routine trop complexe',d:'Au-del\u00e0 de 5 produits, le risque d\'interactions entre actifs augmente significativement. Simplifier pour maximiser l\'efficacit\u00e9 de chaque actif.'});
  if(has('age','plus45')&&!isMature) facteurs.push({t:'Peau mature, adaptation n\u00e9cessaire',d:'Apr\u00e8s 45 ans, introduire progressivement des actifs r\u00e9g\u00e9n\u00e9rants. Le renouvellement cellulaire ralenti n\u00e9cessite une exfoliation enzymatique r\u00e9guli\u00e8re.'});
  if(facteurs.length===0) facteurs.push({t:'Environnement favorable',d:'Aucun facteur aggravant majeur identifi\u00e9. La r\u00e9gularit\u00e9 de la routine est votre principal levier d\'am\u00e9lioration.'});

  var spfMsg;
  if(has('spf','spf_50')){
    spfMsg={t:'Excellente pratique, SPF 50 quotidien confirm\u00e9.',d:'Votre protection est optimale. C\'est le geste anti-\u00e2ge et anti-taches le plus efficace disponible.'};
  } else if(has('spf','spf_insuffisant')){
    spfMsg={t:'SPF insuffisant, passer au SPF 50 d\u00e8s maintenant.',d:'Un SPF < 50 laisse passer jusqu\'\u00e0 20% des UV. SPF 50 tous les matins sans exception, m\u00eame nuageux, m\u00eame en int\u00e9rieur pr\u00e8s d\'une fen\u00eatre.'};
  } else if(has('spf','spf_ete')){
    spfMsg={t:'Action prioritaire : SPF 50 du 1er janvier au 31 d\u00e9cembre.',d:'Les UVA ne varient que de 20% entre l\'\u00e9t\u00e9 et l\'hiver. La protection saisonni\u00e8re prot\u00e8ge contre 20% des dommages annuels seulement.'};
  } else {
    spfMsg={t:'Action imm\u00e9diate : commencer le SPF 50 d\u00e8s demain matin.',d:'Sans SPF 50, tous vos actifs correcteurs sont moins efficaces, les UV annulent ou inversent leurs effets quotidiennement.'};
  }

  /* ── SCORES DYNAMIQUES ── */
  var scores=ndCalcScores(baseScores);

  /* ── CONSEILS UNIVERSELS ── */
  var conseilsUniversels=[
    {icon:'',t:'Boire 1,5 \u00e0 2 litres d\'eau par jour',d:'L\'hydratation cutan\u00e9e commence de l\'int\u00e9rieur. Aucun s\u00e9rum ne peut compenser une d\u00e9shydratation syst\u00e9mique.'},
    {icon:'',t:'SPF 50 tous les matins sans exception',d:'Recommand\u00e9 pour tous les types de peau, toute l\'ann\u00e9e. C\'est le geste anti-\u00e2ge et anti-taches le plus efficace qui existe.'},
  ];
  var tousConseils=conseilsUniversels.concat(conseils);

  return {profil:profil,desc:desc,mecanisme:mecanisme,produits:produits,routine:routine,facteurs:facteurs,alertes:alertes,conseils:conseils,tousConseils:tousConseils,scores:scores,spfMsg:spfMsg};
}

function ndRenderResults(rd){
  document.getElementById('nd-result').style.display='block';

  document.getElementById('nr-profil').textContent=rd.profil;
  document.getElementById('nr-desc').textContent=rd.desc;
  document.getElementById('nr-spf-t').textContent=rd.spfMsg.t;
  document.getElementById('nr-spf-d').textContent=rd.spfMsg.d;
  document.getElementById('nr-email-confirm').textContent=NEMAIL;

  var ctaEl = document.getElementById('nr-cta');
  ctaEl.href = rd.produits[0] ? rd.produits[0].u : '/collections/all';
  ctaEl.setAttribute('target', '_blank');
  ctaEl.setAttribute('rel', 'noopener');

  if(rd.mecanisme){
    document.getElementById('nr-mecanisme').style.display='block';
    document.getElementById('nr-mecanisme-text').textContent=rd.mecanisme;
  }

  /* ── RENDER SCORES (charte alignée) ── */
  var sk=Object.keys(rd.scores);
  document.getElementById('nr-scores').innerHTML=sk.map(function(k){
    return '<div style="background:'+C_BG+';padding:20px 12px;text-align:center;"><p style="font-family:'+FONT_SERIF+';font-size:24px;font-weight:400;color:'+C_ACCENT+';margin:0 0 4px;">'+rd.scores[k]+'%</p><p style="font-family:'+FONT_MONO+';font-size:9px;letter-spacing:1px;color:'+C_MUTED+';margin:0;text-transform:uppercase;">'+k.replace(/_/g,' ')+'</p></div>';
  }).join('');

  /* ── RENDER ALERTES (charte alignée) ── */
  if(rd.alertes.length>0){
    document.getElementById('nr-alertes-block').style.display='block';
    document.getElementById('nr-alertes').innerHTML=rd.alertes.map(function(a){
      return '<div class="alerte-card"><span style="color:'+C_ACCENT+';font-size:14px;flex-shrink:0;">\u26a0</span><div><p style="font-family:'+FONT_MONO+';font-size:12px;font-weight:500;color:'+C_TEXT+';margin:0 0 4px;">'+a.t+'</p><p style="font-family:'+FONT_MONO+';font-size:12px;color:'+C_MUTED+';margin:0;line-height:1.7;">'+a.d+'</p></div></div>';
    }).join('');
  }

  /* ── RENDER FACTEURS (charte alignée) ── */
  document.getElementById('nr-facteurs').innerHTML=rd.facteurs.map(function(f){
    return '<div class="facteur-card"><span style="color:'+C_ACCENT+';font-size:13px;flex-shrink:0;margin-top:2px;">\u2192</span><div><p style="font-family:'+FONT_MONO+';font-size:12px;font-weight:500;color:'+C_TEXT+';margin:0 0 4px;">'+f.t+'</p><p style="font-family:'+FONT_MONO+';font-size:12px;color:'+C_MUTED+';margin:0;line-height:1.7;">'+f.d+'</p></div></div>';
  }).join('');

  /* ── RENDER ROUTINE (charte alignée) ── */
  document.getElementById('nr-routine').innerHTML=rd.routine.map(function(r){
    return '<div style="border:1px solid '+C_BORDER+';overflow:hidden;"><div style="background:'+C_ACCENT+';padding:10px 18px;"><p style="font-family:'+FONT_MONO+';font-size:9px;font-weight:500;letter-spacing:3px;color:#F5F2EA;text-transform:uppercase;margin:0;">'+r.m+'</p></div><div style="padding:16px 18px;">'+r.s.map(function(s,i){
      return '<div style="display:flex;align-items:flex-start;gap:12px;'+(i>0?'margin-top:12px;':'')+'"><div class="step-num">'+(i+1)+'</div><p style="font-family:'+FONT_MONO+';font-size:12px;color:'+C_TEXT+';margin:0;line-height:1.7;">'+s+'</p></div>';
    }).join('')+'</div></div>';
  }).join('');

  /* ── RENDER PRODUITS (charte alignée) ── */
  document.getElementById('nr-produits').innerHTML=rd.produits.map(function(p){
    var cls=p.star?'produit-star':'produit-normal';
    var img=PRODUCT_IMAGES[p.u]||'';
    var opt=ndEstOption(p);
    if(opt) cls+=' produit-option';
    return '<div class="'+cls+'">'+
      (p.star?'<span class="produit-badge">Priorit\u00e9 1</span>':'')+
      (opt?'<span class="produit-tag">'+OPTION_LABEL+'</span>':'')+
      '<div class="prod-row">'+
      (img?'<a class="prod-img" href="'+p.u+'" target="_blank" rel="noopener"><img src="'+img+'" alt="'+p.n+'" loading="lazy"></a>':'')+
      '<div class="prod-body">'+
      '<div class="prod-text">'+
      '<p class="prod-name">'+p.n+'</p>'+
      '<p class="prod-desc">'+p.d+'</p>'+
      '<p class="prod-ordre">'+p.ordre+'</p>'+
      '</div>'+
      '<div class="prod-meta">'+
      '<p class="prod-price">'+p.p+'</p>'+
      '<div class="prod-actions">'+
      '<a class="prod-link" href="'+p.u+'" target="_blank" rel="noopener">Voir le produit \u2192</a>'+
      '<button type="button" class="prod-add" data-handle="'+p.u.split('/').pop()+'" title="Ajouter au panier" aria-label="Ajouter '+p.n+' au panier">+</button>'+
      '</div></div></div></div></div>';
  }).join('');

  /* ── RENDER OFFRE ROUTINE COMPLETE ── */
  var bundleEl=document.getElementById('nr-bundle');
  if(bundleEl){
    var lot=ndProduitsDuLot(rd.produits);
    if(lot.length>=ROUTINE_MIN){
      var t=ndRoutineTotaux(lot);
      bundleEl.innerHTML=
        '<div class="bundle">'+
        '<p class="bundle-eyebrow">Votre routine compl\u00e8te</p>'+
        '<p class="bundle-title">Les '+t.n+' produits de votre protocole, '+ROUTINE_PCT+'\u00a0% de remise.</p>'+
        '<p class="bundle-text">Ils ont \u00e9t\u00e9 s\u00e9lectionn\u00e9s pour agir ensemble, dans cet ordre pr\u00e9cis. La remise s\u2019applique automatiquement au panier. Le Growth S\u00e9rum reste \u00e0 ajouter s\u00e9par\u00e9ment si vous le souhaitez.</p>'+
        '<div class="bundle-prices"><span class="bundle-old">'+ndEuros(t.total)+'</span><span class="bundle-new">'+ndEuros(t.final)+'</span><span class="bundle-save">\u2212'+ndEuros(t.remise)+'</span></div>'+
        '<button type="button" class="bundle-btn" id="nr-bundle-btn">Ajouter ma routine compl\u00e8te \u2192</button>'+
        '</div>';
      NPRODUITS=lot;
    } else {
      bundleEl.innerHTML='';
    }
  }

  /* ── RENDER CONSEILS (charte alignée) ── */
  document.getElementById('nr-conseils').innerHTML=rd.tousConseils.map(function(c){
    return '<div class="facteur-card"><span style="color:'+C_ACCENT+';font-size:13px;flex-shrink:0;margin-top:2px;">\u2192</span><div><p style="font-family:'+FONT_MONO+';font-size:12px;font-weight:500;color:'+C_TEXT+';margin:0 0 3px;">'+c.t+'</p><p style="font-family:'+FONT_MONO+';font-size:12px;color:'+C_MUTED+';margin:0;line-height:1.7;">'+c.d+'</p></div></div>';
  }).join('');
}

function ndReset(){
  NA={};NHIST=[];NCUR=0;NPRENOM='';NEMAIL='';
  document.getElementById('nd-result').style.display='none';
  document.getElementById('nd-intro').style.display='block';
}

function ndBuildUrl(answers, pn){
  function flat(val){
    if(!val) return '';
    return Array.isArray(val)?val.join(','):val;
  }
  var base = window.location.origin + window.location.pathname;
  var params = new URLSearchParams();
  params.set('t', flat(answers.type)||'');
  params.set('s', flat(answers.sensibilite)||'');
  params.set('h', flat(answers.hydratation)||'');
  params.set('i', flat(answers.imperfections)||'');
  params.set('ta', flat(answers.taches)||'');
  params.set('a', flat(answers.age)||'');
  params.set('m', flat(answers.mode_de_vie)||'');
  params.set('al', flat(answers.alimentation)||'');
  params.set('n', flat(answers.nettoyage)||'');
  params.set('r', flat(answers.routine_actuelle)||'');
  params.set('o', flat(answers.objectif)||'');
  params.set('spf', flat(answers.spf)||'');
  if(pn) params.set('pn', pn);
  return base + '#diag&' + params.toString();
}

function ndLoadFromUrl(){
  var hash = window.location.hash;
  if(!hash || hash.indexOf('#diag&') === -1){
    var search = window.location.search;
    if(!search || (!search.includes('t=') && !search.includes('spf='))) return false;
    hash = '#diag&' + search.substring(1);
  }
  var rawParams = hash.replace('#diag&', '');
  var params = new URLSearchParams(rawParams);
  if(!params.get('t') && !params.get('spf')) return false;
  function toArr(val){ return val ? val.split(',') : []; }
  NA.type = toArr(params.get('t') || '');
  NA.sensibilite = toArr(params.get('s') || '');
  NA.hydratation = toArr(params.get('h') || '');
  NA.imperfections = toArr(params.get('i') || '');
  NA.taches = toArr(params.get('ta') || '');
  NA.age = toArr(params.get('a') || '');
  NA.mode_de_vie = toArr(params.get('m') || '');
  NA.alimentation = toArr(params.get('al') || '');
  NA.nettoyage = toArr(params.get('n') || '');
  NA.routine_actuelle = toArr(params.get('r') || '');
  NA.objectif = toArr(params.get('o') || '');
  NA.spf = toArr(params.get('spf') || '');
  NPRENOM = params.get('pn') || '';
  NEMAIL = '';
  return true;
}

/* ── AJOUT AU PANIER ── */

/* Comportement après ajout :
   'stay'   → reste sur le diagnostic, met à jour compteur + tiroir
   'drawer' → idem, et ouvre le tiroir de panier
   'cart'   → redirige vers la page /cart                                */
var CART_AFTER_ADD = 'drawer';

/* Sections du thème à redessiner après ajout (noms Dawn par défaut). */
var CART_SECTIONS = 'cart-icon-bubble,cart-drawer,cart-notification';

function ndCartRoot(){
  if(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) return window.Shopify.routes.root;
  return '/';
}

function ndAddToCart(handle,btn){
  if(btn.classList.contains('is-loading')) return;
  btn.classList.remove('is-error','is-done');
  btn.classList.add('is-loading');
  btn.textContent='\u00b7\u00b7\u00b7';

  var root=ndCartRoot();

  fetch(root+'products/'+handle+'.js',{headers:{'Accept':'application/json'},credentials:'same-origin'})
    .then(function(r){
      if(!r.ok) throw new Error('Produit introuvable ('+r.status+') : handle "'+handle+'".');
      return r.json();
    })
    .then(function(prod){
      var variants=prod.variants||[];
      var v=variants.filter(function(x){return x.available;})[0];
      if(!v && variants.length) throw new Error('Aucune variante achetable pour "'+handle+'".');
      if(!v) throw new Error('Ce produit n\'a aucune variante.');
      return fetch(root+'cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        credentials:'same-origin',
        body:JSON.stringify({
          items:[{id:v.id,quantity:1}],
          sections:CART_SECTIONS,
          sections_url:window.location.pathname
        })
      });
    })
    .then(function(r){
      return r.json().then(function(data){
        if(!r.ok) throw new Error('Ajout refus\u00e9 ('+r.status+') : '+(data.description||data.message||''));
        return data;
      });
    })
    .then(function(data){
      btn.classList.remove('is-loading');
      btn.classList.add('is-done');
      btn.textContent='\u2713';
      setTimeout(function(){ btn.classList.remove('is-done'); btn.textContent='+'; },2200);

      if(CART_AFTER_ADD==='cart'){ window.location.href=root+'cart'; return; }

      ndApplyCartSections(data.sections);
      ndNotifyTheme(root);
      if(CART_AFTER_ADD==='drawer') ndOpenCartDrawer();
    })
    .catch(function(e){
      console.log('[Panier] ECHEC :',e.message||e);
      btn.classList.remove('is-loading');
      btn.classList.add('is-error');
      btn.textContent='!';
      btn.title=e.message||'Ajout impossible';
      setTimeout(function(){
        btn.classList.remove('is-error');
        btn.textContent='+';
        btn.title='Ajouter au panier';
      },2600);
    });
}

/* Remplace dans la page le HTML renvoye par Shopify pour chaque section.
   On recopie AUSSI les attributs (class, hidden...) : le theme s'en sert pour
   afficher ou masquer la liste, par exemple via une classe "is-empty" heritee
   du moment ou la page a ete chargee avec un panier vide. */
function ndApplyCartSections(sections){
  if(!sections) return;
  Object.keys(sections).forEach(function(key){
    var html=sections[key];
    if(!html) return;
    var parsed=new DOMParser().parseFromString(html,'text/html');
    var selectors=['#'+key,'#shopify-section-'+key,key];
    for(var i=0;i<selectors.length;i++){
      var target,source;
      try{
        target=document.querySelector(selectors[i]);
        source=parsed.querySelector(selectors[i]);
      }catch(err){ continue; }
      if(target&&source){
        target.innerHTML=source.innerHTML;
        ndSyncAttributes(target,source);
        // Les sous-elements du theme portent souvent l'etat "vide" eux aussi
        ndSyncEmptyState(target,source);
        console.log('[Panier] section redessinee :',selectors[i]);
        break;
      }
    }
  });
}

function ndSyncAttributes(target,source){
  // Retire les attributs disparus (sauf ceux ajoutes par l'ouverture du tiroir)
  var keep=['open','style'];
  Array.prototype.slice.call(target.attributes).forEach(function(a){
    if(keep.indexOf(a.name)===-1 && !source.hasAttribute(a.name)){
      target.removeAttribute(a.name);
    }
  });
  Array.prototype.slice.call(source.attributes).forEach(function(a){
    if(a.name==='class'){
      // On conserve les classes d'ouverture posees par le theme
      var opened=['active','is-open','open','animate'].filter(function(c){
        return target.classList.contains(c);
      });
      target.setAttribute('class',a.value);
      opened.forEach(function(c){ target.classList.add(c); });
    } else {
      target.setAttribute(a.name,a.value);
    }
  });
}

function ndSyncEmptyState(target,source){
  ['.is-empty','.cart-drawer__empty','[data-cart-empty]'].forEach(function(sel){
    var t=target.querySelector(sel), sc=source.querySelector(sel);
    if(t&&!sc) t.classList.remove('is-empty');
  });
  if(!source.classList.contains('is-empty')) target.classList.remove('is-empty');
}

/* Ouvre le tiroir de panier, quelle que soit sa forme selon le theme. */
function ndOpenCartDrawer(){
  var drawer=document.querySelector('cart-drawer');
  if(drawer){
    if(typeof drawer.open==='function'){ drawer.open(); return; }
    drawer.classList.add('active','is-open','open');
    drawer.removeAttribute('hidden');
    return;
  }
  var notif=document.querySelector('cart-notification');
  if(notif&&typeof notif.open==='function'){ notif.open(); return; }
  var toggle=document.querySelector('[data-cart-drawer-toggle],[data-drawer-open="cart"],.js-drawer-open-cart,#cart-icon-bubble');
  if(toggle) toggle.click();
}

/* Evenements ecoutes par les themes, plus mise a jour des compteurs simples. */
function ndNotifyTheme(root){
  fetch(root+'cart.js',{headers:{'Accept':'application/json'},credentials:'same-origin'})
    .then(function(r){return r.json();})
    .then(function(cart){
      console.log('[Panier]',cart.item_count,'article(s)');
      ['cart:refresh','cart:build','cart:updated','ajaxProduct:added'].forEach(function(name){
        document.dispatchEvent(new CustomEvent(name,{bubbles:true,detail:{cart:cart}}));
      });
      if(window.jQuery) window.jQuery(document.body).trigger('added.ajaxProduct');
      document.querySelectorAll('.cart-count,.cart-count-bubble span,[data-cart-count]').forEach(function(el){
        if(el.children.length===0) el.textContent=cart.item_count;
      });
    })
    .catch(function(e){console.log('[Panier] cart.js :',e);});
}

/* Ajoute tous les produits recommandes puis applique la remise. */
function ndAddRoutine(btn){
  if(btn.disabled) return;
  var label=btn.textContent;
  btn.disabled=true;
  btn.classList.add('is-loading');
  btn.textContent='Pr\u00e9paration du panier\u2026';

  var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  var jobs=NPRODUITS.map(function(p){
    var handle=p.u.split('/').pop();
    return fetch(root+'products/'+handle+'.js',{headers:{'Accept':'application/json'},credentials:'same-origin'})
      .then(function(r){ if(!r.ok) throw new Error(handle); return r.json(); })
      .then(function(prod){
        var vs=prod.variants||[];
        var v=vs.filter(function(x){return x.available;})[0];
        if(!v) throw new Error('indisponible : '+handle);
        return {id:v.id,quantity:1};
      });
  });

  Promise.all(jobs)
    .then(function(items){
      return fetch(root+'cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        credentials:'same-origin',
        body:JSON.stringify({items:items})
      });
    })
    .then(function(r){
      return r.json().then(function(d){
        if(!r.ok) throw new Error(d.description||d.message||'ajout refus\u00e9');
        return d;
      });
    })
    .then(function(){
      btn.textContent='Redirection vers le panier\u2026';
      window.location.href = ROUTINE_AUTO
        ? root+'cart'
        : root+'discount/'+ROUTINE_CODE+'?redirect='+encodeURIComponent(root+'cart');
    })
    .catch(function(e){
      console.log('[Routine] ECHEC :',e.message||e);
      btn.classList.remove('is-loading');
      btn.classList.add('is-error');
      btn.textContent='Un produit est indisponible';
      setTimeout(function(){
        btn.disabled=false;
        btn.classList.remove('is-error');
        btn.textContent=label;
      },3000);
    });
}

function ndBindEvents(){
  var startBtn=document.getElementById('nd-start-btn');
  var continueBtn=document.getElementById('nd-continue');
  var backBtn=document.getElementById('nd-back');
  var submitBtn=document.getElementById('nd-submit-email');
  var resetBtn=document.getElementById('nd-reset-btn');
  if(startBtn) startBtn.addEventListener('click',ndStart);
  if(continueBtn) continueBtn.addEventListener('click',ndContinue);
  if(backBtn) backBtn.addEventListener('click',ndBack);
  if(submitBtn) submitBtn.addEventListener('click',ndSubmitEmail);
  if(resetBtn) resetBtn.addEventListener('click',ndReset);

  // Delegation : les cartes produits sont generees apres coup
  var bundleWrap=document.getElementById('nr-bundle');
  if(bundleWrap) bundleWrap.addEventListener('click',function(e){
    var b=e.target.closest('#nr-bundle-btn');
    if(!b) return;
    e.preventDefault();
    ndAddRoutine(b);
  });

  var prodWrap=document.getElementById('nr-produits');
  if(prodWrap) prodWrap.addEventListener('click',function(e){
    var btn=e.target.closest('.prod-add');
    if(!btn) return;
    e.preventDefault();
    ndAddToCart(btn.getAttribute('data-handle'),btn);
  });
}

function ndInit(){
  ndBindEvents();
  function tryLoadFromUrl(attempt){
    var hash = window.location.hash;
    var params = new URLSearchParams(window.location.search);
    if((hash && hash.indexOf('#diag&') !== -1) || params.get('t') || params.get('spf')){
      if(ndLoadFromUrl()){
        document.getElementById('nd-intro').style.display='none';
        ndShowResults();
        setTimeout(function(){
          var result = document.getElementById('nd-result');
          if(result) result.scrollIntoView({behavior:'smooth', block:'start'});
        }, 100);
      }
    } else if(attempt < 5){
      setTimeout(function(){ tryLoadFromUrl(attempt + 1); }, 200);
    }
  }
  tryLoadFromUrl(0);
}

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',ndInit);
} else {
  ndInit();
}